import { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useLeads } from '../context/LeadsContext';
import { registrar } from '../services/auditoria';

const FB_PROJ = 'migravip-e1afb';

// ─── Catálogo Avec (alinhado 1:1 com a Calculadora — valores MENSAIS) ─────────
const CATALOGO_PLATAFORMA = [
  { nome: 'AVECGO / Até 2', mrr: 89.9,   faixaIA: 'Até 2'     },
  { nome: 'Até 2 Prof.',    mrr: 99.9,   faixaIA: 'Até 2'     },
  { nome: 'Até 5 Prof.',    mrr: 163.9,  faixaIA: '3 a 5'     },
  { nome: 'Até 10 Prof.',   mrr: 286.9,  faixaIA: 'Até 10'    },
  { nome: 'Até 20 Prof.',   mrr: 397.9,  faixaIA: 'Até 20'    },
  { nome: 'Até 30 Prof.',   mrr: 546.9,  faixaIA: 'Até 30'    },
  { nome: 'Até 40 Prof.',   mrr: 626.9,  faixaIA: 'Até 40'    },
  { nome: 'Até 50 Prof.',   mrr: 751.9,  faixaIA: 'Até 50'    },
  { nome: 'Ilimitado',      mrr: 1279.9, faixaIA: 'Ilimitado' },
];

const CATALOGO_MODULOS = [
  { nome: 'Módulo Franquia',          mrr: 218.9 },
  { nome: 'NF de Serviço (NFS-e)',    mrr: 114.9 },
  { nome: 'NF de Produto',            mrr: 114.9 },
  { nome: '1.000 SMS Avec',           mrr: 149.9 },
  { nome: '500 SMS Avec',             mrr: 79.9  },
  { nome: 'White Label (manutenção)', mrr: 500   },
];

const FAIXAS_IA = [
  { l: 'Até 2',    ci: 75,  cs: 150, cm: 100,  combo: 199  },
  { l: '3 a 5',    ci: 150, cs: 240, cm: 170,  combo: 299  },
  { l: 'Até 10',   ci: 240, cs: 260, cm: 320,  combo: 499  },
  { l: 'Até 20',   ci: 299, cs: 420, cm: 330,  combo: 699  },
  { l: 'Até 30',   ci: 360, cs: 540, cm: 420,  combo: 899  },
  { l: 'Até 40',   ci: 480, cs: 780, cm: 570,  combo: 1299 },
  { l: 'Até 50',   ci: 540, cs: 899, cm: 660,  combo: 1499 },
  { l: 'Ilimitado',ci: 599, cs: 720, cm: 1020, combo: 2000 },
];

const IA_MODS = [
  { key: 'ci', ico: '🔔', nome: 'Confirmação' },
  { key: 'cs', ico: '📅', nome: 'Agendamento' },
  { key: 'cm', ico: '📣', nome: 'Marketing'   },
];

// Compat de export (Relatórios importa PRODUTOS_AVEC/calcMRR)
const PRODUTOS_AVEC = [...CATALOGO_PLATAFORMA.map(p => ({ nome: p.nome, mrr: p.mrr })), ...CATALOGO_MODULOS];

const produtoMRR = (nome) => {
  const p = CATALOGO_PLATAFORMA.find(x => x.nome === nome) || CATALOGO_MODULOS.find(x => x.nome === nome);
  return p ? p.mrr : null;
};
const noCatalogo = (nome) => produtoMRR(nome) !== null;

// Produtos "de preço fixo" do cliente (exclui IA, que tem seção própria)
const getProdutos = (c) => {
  const arr = Array.isArray(c.produtos) ? c.produtos : [c?.nomeContrato, c?.nomeComponente];
  return arr.filter(Boolean).filter(n => !/ia completa/i.test(n));
};
// Módulos de IA do cliente (migra legado "IA Completa (...)" → os 3)
const getIaModulos = (c) => {
  if (Array.isArray(c.iaModulos)) return c.iaModulos;
  const raw = (Array.isArray(c.produtos) ? c.produtos : [c?.nomeContrato, c?.nomeComponente]).filter(Boolean).join(' ');
  return /ia completa/i.test(raw) ? ['ci', 'cs', 'cm'] : [];
};
// Faixa da IA: escolhida manualmente OU derivada do plano de plataforma do cliente
const FAIXA_POR_PROF = { 2: 'Até 2', 5: '3 a 5', 10: 'Até 10', 20: 'Até 20', 30: 'Até 30', 40: 'Até 40', 50: 'Até 50' };
// Devolve a faixa de IA do cliente, ou null quando nao da pra saber.
// So o nome exato do catalogo nao bastava: base migrada tem "Plataforma — Ate 10
// Profissionais", que caia no 'Ate 2' e jogava o valor da IA pra baixo.
const faixaDoPlanoOuNull = (produtos) => {
  const exato = produtos.map(n => CATALOGO_PLATAFORMA.find(p => p.nome === n)).find(Boolean);
  if (exato) return exato.faixaIA;
  const txt = produtos.join(' ').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  if (/ilimitad/.test(txt)) return 'Ilimitado';
  if (/avecgo/.test(txt)) return 'Até 2';
  const m = txt.match(/ate\s*(\d+)\s*(prof|profissiona)/);
  return m ? (FAIXA_POR_PROF[parseInt(m[1], 10)] || null) : null;
};
const faixaDoPlano = (produtos) => faixaDoPlanoOuNull(produtos) || 'Até 2';
const mrrIA = (modulos, faixaLabel) => {
  if (!modulos || !modulos.length) return 0;
  const f = FAIXAS_IA.find(x => x.l === faixaLabel) || FAIXAS_IA[0];
  if (['ci', 'cs', 'cm'].every(k => modulos.includes(k))) return f.combo;
  return modulos.reduce((s, k) => s + (f[k] || 0), 0);
};

// MRR calculado pelo catálogo (produtos + IA)
const calcMRRCliente = (c) => {
  const prods = getProdutos(c);
  const somaProd = prods.reduce((s, n) => s + (produtoMRR(n) || 0), 0);
  const ia = mrrIA(getIaModulos(c), c.iaFaixa || faixaDoPlano(prods));
  return somaProd + ia;
};

// Compat: soma de dois nomes (assinatura antiga usada em outras telas)
const calcMRR = (a, b) => (produtoMRR(a) || 0) + (produtoMRR(b) || 0);

// Valor efetivo: usa o negociado se houver, senão o calculado
const mrrEfetivo = (c) => {
  const raw = c?.mrrCustom;
  if (raw !== undefined && raw !== null && String(raw).trim() !== '') {
    const v = typeof raw === 'number' ? raw : valorToNumber(raw);
    if (v !== '' && !isNaN(v)) return v;   // permite 0 (cortesia negociada)
  }
  return calcMRRCliente(c);
};

const mesAtual = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

// ─── Firestore helpers ────────────────────────────────────────────────────────
async function fsGet(path, token) {
  const r = await fetch(
    `https://firestore.googleapis.com/v1/projects/${FB_PROJ}/databases/(default)/documents/${path}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  if (!r.ok) return null;
  return r.json();
}

async function fsSet(path, fields, token) {
  await fetch(
    `https://firestore.googleapis.com/v1/projects/${FB_PROJ}/databases/(default)/documents/${path}`,
    { method: 'PATCH',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ fields }) }
  );
}

async function fsList(path, token) {
  const r = await fetch(
    `https://firestore.googleapis.com/v1/projects/${FB_PROJ}/databases/(default)/documents/${path}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  if (!r.ok) return [];
  const data = await r.json();
  return data.documents || [];
}

// POST numa coleção: o Firestore gera o id. É assim que nasce um chamado.
async function fsCreate(path, fields, token) {
  const r = await fetch(
    `https://firestore.googleapis.com/v1/projects/${FB_PROJ}/databases/(default)/documents/${path}`,
    { method: 'POST',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ fields }) }
  );
  if (!r.ok) throw new Error(erroFirestore(r.status));
  return r.json();
}

// Diferente do fsSet: este avisa quando dá errado. Chamado que some calado é
// pior do que chamado que não salva.
async function fsPatch(path, fields, token) {
  const r = await fetch(
    `https://firestore.googleapis.com/v1/projects/${FB_PROJ}/databases/(default)/documents/${path}`,
    { method: 'PATCH',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ fields }) }
  );
  if (!r.ok) throw new Error(erroFirestore(r.status));
}

async function fsDelete(path, token) {
  const r = await fetch(
    `https://firestore.googleapis.com/v1/projects/${FB_PROJ}/databases/(default)/documents/${path}`,
    { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } }
  );
  if (!r.ok) throw new Error(erroFirestore(r.status));
}

const erroFirestore = (status) => status === 403 || status === 401
  ? 'as regras do Firestore ainda não liberam a coleção "chamados" (peça para publicar a regra)'
  : 'o servidor respondeu ' + status;

const clientesToFields = (clientes) => ({
  data:      { stringValue: JSON.stringify(clientes) },
  updatedAt: { stringValue: new Date().toISOString() },
});

const docToClientes = (doc) => {
  try { return JSON.parse(doc.fields?.data?.stringValue || '[]'); }
  catch { return []; }
};

// ─── Parsers (CSV / TSV / XLSX) ───────────────────────────────────────────────
const normHeader = (h) => String(h).trim().toLowerCase()
  .replace(/\s+/g, '_')
  .normalize('NFD').replace(/[\u0300-\u036f]/g, '');

function valorToNumber(v) {
  if (v == null) return '';
  let s = String(v).replace(/[R$\s]/g, '').trim();
  if (s === '') return '';
  const temVirgula = s.indexOf(',') > -1;
  const pontos = (s.match(/\./g) || []).length;
  if (temVirgula) s = s.replace(/\./g, '').replace(',', '.');
  else if (pontos > 1) s = s.replace(/\./g, '');
  const n = parseFloat(s);
  return isNaN(n) ? '' : n;
}

function detectDelim(line) {
  const t = (line.match(/\t/g) || []).length;
  const pv = (line.match(/;/g) || []).length;
  const c = (line.match(/,/g) || []).length;
  if (t >= pv && t >= c && t > 0) return '\t';
  if (pv >= c && pv > 0) return ';';
  if (c > 0) return ',';
  return '\t';
}

function splitDelimited(text, delim) {
  const s = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  const rows = []; let row = [], f = '', q = false, i = 0;
  while (i < s.length) {
    const ch = s[i];
    if (q) {
      if (ch === '"') { if (s[i + 1] === '"') { f += '"'; i += 2; continue; } q = false; i++; continue; }
      f += ch; i++; continue;
    }
    if (ch === '"') { q = true; i++; continue; }
    if (ch === delim) { row.push(f); f = ''; i++; continue; }
    if (ch === '\n') { row.push(f); rows.push(row); row = []; f = ''; i++; continue; }
    f += ch; i++;
  }
  if (f.length || row.length) { row.push(f); rows.push(row); }
  return rows;
}

// Divide uma célula "Produtos" em vários (aceita | ; ou , como separador interno)
const splitProdutos = (s) => String(s || '').split(/[|;,]/).map(x => x.trim()).filter(Boolean);

// Status/periodicidade da Avec vem em CAIXA ALTA. O painel compara com 'Ativo',
// 'Cancelado'... entao sem normalizar os contadores e os filtros nao enxergam ninguem.
const STATUS_MAP = { ATIVO:'Ativo', CANCELADO:'Cancelado', CANCELLED:'Cancelado', CHURN:'Cancelado',
                     SUSPENSO:'Suspenso', EXPIRADO:'Expirado', INADIMPLENTE:'Suspenso' };
const PERIODO_MAP = { MENSAL:'Mensal', ANUAL:'Anual', AVULSO:'Avulso', 'ONE-SHOT':'Avulso',
                      SEMESTRAL:'Anual', TRIMESTRAL:'Mensal' };
const normStatus = (v, padrao) => {
  const k = String(v || '').trim().toUpperCase();
  return STATUS_MAP[k] || (k ? k.charAt(0) + k.slice(1).toLowerCase() : padrao);
};
const normPeriodo = (v, padrao) => {
  const k = String(v || '').trim().toUpperCase();
  return PERIODO_MAP[k] || (k ? k.charAt(0) + k.slice(1).toLowerCase() : padrao);
};

// <input type="date"> exige aaaa-mm-dd. Data em dd/mm/aaaa ou serial do Excel aparecia vazia.
const dataISO = (v) => {
  const s = String(v == null ? '' : v).trim();
  if (!s) return '';
  // FIX: no export da Avec, campo de data vazio vem como 0 ou "0,00".
  // new Date('0') devolve 01/01/2000 — cliente sem contrato ganhava data inventada.
  if (/^0+([.,]0+)?$/.test(s)) return '';
  let m = s.match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})$/);
  if (m) return m[3] + '-' + m[2].padStart(2, '0') + '-' + m[1].padStart(2, '0');
  m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return m[0];
  if (/^\d{5}(\.\d+)?$/.test(s) && parseFloat(s) > 20000) {
    const d = new Date(Date.UTC(1899, 11, 30) + Math.round(parseFloat(s)) * 86400000);
    return d.toISOString().slice(0, 10);
  }
  const d = new Date(s);
  return isNaN(d) ? '' : d.toISOString().slice(0, 10);
};

// Le os modulos de IA da planilha. Aceita 'ci,cs,cm', os nomes por extenso, os
// componentes AVECIA da Avec e 'Combo'/'Completa' (que valem os tres).
const parseIaModulos = (celula, produtos) => {
  const txt = String(celula || '') + ' ' + (Array.isArray(produtos) ? produtos.join(' ') : '');
  const t = txt.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  if (!t.trim()) return [];
  if (/\b(combo|completa|completo|todos|full)\b/.test(t)) return ['ci', 'cs', 'cm'];
  const out = [];
  if (/\bci\b|confirmacao/.test(t)) out.push('ci');
  if (/\bcs\b|agendamento/.test(t)) out.push('cs');
  if (/\bcm\b|marketing/.test(t))   out.push('cm');
  return out;
};

function rowsToClientes(rows) {
  if (!rows || rows.length < 2) return [];
  const header = rows[0].map(normHeader);
  const out = [];
  rows.slice(1).forEach((cols, i) => {
    if (!cols || cols.every(c => String(c).trim() === '')) return;
    const obj = {};
    header.forEach((h, idx) => { obj[h] = (cols[idx] != null ? String(cols[idx]) : '').trim(); });

    // produtos: coluna "produtos" (multi) OU nome_contrato + nome_componente
    let produtos = [];
    if (obj['produtos']) produtos = splitProdutos(obj['produtos']);
    else produtos = [obj['nome_contrato'] || obj['contrato'] || '', obj['nome_componente'] || obj['componente'] || ''].filter(Boolean);

    const valorRaw = obj['valor_negociado'] || obj['valor'] || obj['mrr'] || obj['valor_mrr'] || '';

    out.push({
      id:                    Date.now() + i,
      clienteId:             obj['cliente_id']            || obj['id']            || '',
      documento:             obj['documento']              || obj['cnpj']          || '',
      nome:                  obj['nome']                   || '',
      email:                 obj['email']                  || obj['e-mail']        || obj['e_mail'] || '',
      telefone:              String(obj['telefone'] || obj['whatsapp'] || obj['celular'] || obj['fone'] || obj['phone'] || '').replace(/\D/g, ''),
      sistemaCobranca:       obj['sistema_cobranca']       || obj['sistema']       || 'Avec',
      statusContrato:        normStatus(obj['status_contrato'] || obj['status'], 'Ativo'),
      periodicidadeContrato: normPeriodo(obj['periodicidade_contrato'] || obj['periodicidade'], 'Mensal'),
      ativacaoContrato:      dataISO(obj['ativacao_contrato']  || obj['ativacao']  || ''),
      expiracaoContrato:     dataISO(obj['expiracao_contrato'] || obj['expiracao'] || ''),
      aniversario:           dataISO(obj['aniversario'] || obj['data_aniversario'] || obj['aniversario_dono']
                                  || obj['nascimento'] || obj['data_de_nascimento'] || obj['data_nascimento'] || ''),
      contato:               obj['contato'] || obj['responsavel'] || obj['nome_contato'] || '',
      observacao:            obj['observacao'] || obj['obs'] || '',
      produtos,
      iaFaixa:               obj['ia_faixa']               || '',
      iaModulos:             parseIaModulos(obj['ia_modulos'] || obj['ia'] || obj['avecia'] || '', produtos),
      mrrCustom:             valorToNumber(valorRaw),
    });
  });
  return out.filter(c => c.nome);
}

// ─── Exportação da carteira ───────────────────────────────────────────────────
// Os cabeçalhos são exatamente os que rowsToClientes() reconhece na importação:
// o arquivo que sai daqui volta por "Atualizar base" sem perder nada.
const CAB_EXPORT = ['Cliente ID', 'Documento', 'Nome', 'Email', 'Telefone', 'Sistema Cobranca',
  'Status Contrato', 'Periodicidade Contrato', 'Ativacao Contrato', 'Expiracao Contrato',
  'Aniversario', 'Contato', 'Observacao', 'Produtos', 'IA Modulos', 'IA Faixa',
  'Valor Negociado', 'MRR Calculado', 'MRR Final'];

const brData = (iso) => (iso && iso.length >= 10 ? iso.slice(0, 10).split('-').reverse().join('/') : '');
const num2 = (n) => (n === '' || n == null || isNaN(n) ? '' : Number(n).toFixed(2).replace('.', ','));

// o export segue a mesma regra da tela: sem valor para quem não enxerga valor
const COLS_VALOR = ['Valor Negociado', 'MRR Calculado', 'MRR Final'];

const clienteParaLinha = (c) => {
  const prods = getProdutos(c);
  const ia    = getIaModulos(c);
  const neg   = (c.mrrCustom === '' || c.mrrCustom == null) ? '' : valorToNumber(c.mrrCustom);
  return [
    c.clienteId || '', c.documento || '', c.nome || '', c.email || '', c.telefone || '',
    c.sistemaCobranca || '', c.statusContrato || '', c.periodicidadeContrato || '',
    brData(c.ativacaoContrato), brData(c.expiracaoContrato), brData(c.aniversario),
    c.contato || '', c.observacao || '',
    prods.join(' | '),
    ia.join(','),
    c.iaFaixa || faixaDoPlanoOuNull(prods) || '',
    num2(neg), num2(calcMRRCliente(c)), num2(mrrEfetivo(c)),
  ];
};

// CSV pro Excel em português: ponto e vírgula, BOM e CRLF. Sem isso a planilha
// abre tudo na coluna A e com acento quebrado.
const baixarArquivo = (blob, nome) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = nome;
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1500);
};

const baixarCSVClientes = (cab, linhas, nome) => {
  const cel = (v) => '"' + String(v ?? '').replace(/\r?\n/g, ' ').replace(/"/g, '""') + '"';
  const corpo = [cab, ...linhas].map(l => l.map(cel).join(';')).join('\r\n');
  baixarArquivo(new Blob(['﻿' + corpo], { type: 'text/csv;charset=utf-8' }), nome);
};

// Tenta XLSX de verdade; se a lib não estiver instalada, cai no CSV sem travar.
async function exportarClientes(lista, nomeBase, comValores = true) {
  const cab = comValores ? CAB_EXPORT : CAB_EXPORT.filter(h => !COLS_VALOR.includes(h));
  const corta = (l) => comValores ? l : l.slice(0, l.length - COLS_VALOR.length);
  const linhas = lista.map(c => corta(clienteParaLinha(c)));
  try {
    const XLSX = await import('xlsx');
    const ws = XLSX.utils.aoa_to_sheet([cab, ...linhas]);
    ws['!cols'] = cab.map((h, i) => ({ wch: [10, 18, 30, 26, 15, 14, 12, 14, 12, 12, 12, 20, 28, 34, 12, 12, 13, 13, 11][i] || 14 }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Clientes');
    const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    baixarArquivo(new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
      nomeBase + '.xlsx');
    return 'xlsx';
  } catch (e) {
    baixarCSVClientes(cab, linhas, nomeBase + '.csv');
    return 'csv';
  }
}

// ─── O dinheiro mora num documento à parte ────────────────────────────────────
// Esconder a coluna na tela não esconde nada: a carteira é UM documento, e
// quem pode lê-lo recebe o JSON inteiro no navegador — basta abrir o F12.
// Por isso o valor negociado saiu de clientes/dados e foi para
// users/{conta}/financeiro/valores, que a regra nega para o suporte.
//
// O MRR calculado pelo catálogo continua derivável por quem vê os produtos —
// e o suporte PRECISA ver os produtos para atender. O que fica realmente
// protegido é o valor negociado e os totais da carteira.
export const chaveValor = (c) =>
  String(c?.clienteId || String(c?.documento || '').replace(/\D/g, '') || c?.id || '').trim();

export const separarValores = (lista) => {
  const valores = {};
  const limpos = (lista || []).map((c) => {
    const { mrrCustom, ...resto } = c;
    const k = chaveValor(c);
    if (k && mrrCustom !== undefined && mrrCustom !== null && String(mrrCustom).trim() !== '') {
      const n = typeof mrrCustom === 'number' ? mrrCustom : valorToNumber(mrrCustom);
      if (n !== '' && !isNaN(n)) valores[k] = n;
    }
    return resto;
  });
  return { limpos, valores };
};

export const juntarValores = (lista, valores) => (lista || []).map((c) => {
  const v = valores ? valores[chaveValor(c)] : undefined;
  return (v === undefined || v === null) ? c : { ...c, mrrCustom: v };
});

export const valoresToFields = (valores) => ({
  valoresJson: { stringValue: JSON.stringify(valores || {}) },
  updatedAt:   { stringValue: new Date().toISOString() },
});

export const docToValores = (d) => {
  try { return JSON.parse(d?.fields?.valoresJson?.stringValue || '{}'); }
  catch { return {}; }
};

// ─── Mesclagem da base (upsert) ───────────────────────────────────────────────
// A planilha da Avec nao traz WhatsApp, e-mail nem aniversario. Antes, reimportar
// apagava tudo que o franqueado digitou na mao. Aqui a planilha manda no que e
// contrato (status, produtos, MRR, datas) e o que foi digitado a mao e preservado.
const chaveNome = (n) => String(n || '').trim().toLowerCase()
  .normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]/g, '');

function mesclarClientes(antigos, novos) {
  const usados = new Set();
  const acharAntigo = (n) => {
    const porId  = n.clienteId && antigos.find(a => a.clienteId && a.clienteId === n.clienteId && !usados.has(a.id));
    if (porId) return porId;
    const docN = String(n.documento || '').replace(/\D/g, '');
    const porDoc = docN && antigos.find(a => String(a.documento || '').replace(/\D/g, '') === docN && !usados.has(a.id));
    if (porDoc) return porDoc;
    return antigos.find(a => chaveNome(a.nome) === chaveNome(n.nome) && !usados.has(a.id)) || null;
  };

  const resumo = { novos: 0, atualizados: 0, viraramChurn: [], reativados: [], ausentes: [] };
  const lista = novos.map(n => {
    const a = acharAntigo(n);
    if (!a) { resumo.novos++; return n; }
    usados.add(a.id);
    resumo.atualizados++;
    if (a.statusContrato === 'Ativo' && n.statusContrato !== 'Ativo') resumo.viraramChurn.push(n.nome);
    if (a.statusContrato !== 'Ativo' && n.statusContrato === 'Ativo') resumo.reativados.push(n.nome);
    return {
      ...n,
      id:          a.id,                                    // mantem o cadastro, nao cria outro
      email:       n.email       || a.email       || '',    // preenchidos a mao continuam
      telefone:    n.telefone    || a.telefone    || '',
      aniversario: n.aniversario || a.aniversario || '',
      contato:     n.contato     || a.contato     || '',
      observacao:  n.observacao  || a.observacao  || '',
      // a planilha manda quando traz IA; sem IA na planilha, mantem o que foi marcado a mao
      iaModulos:   (Array.isArray(n.iaModulos) && n.iaModulos.length) ? n.iaModulos
                 : (Array.isArray(a.iaModulos) ? a.iaModulos : []),
      iaFaixa:     n.iaFaixa     || a.iaFaixa     || '',
      mrrCustom:   (n.mrrCustom === '' || n.mrrCustom == null) ? (a.mrrCustom ?? '') : n.mrrCustom,
    };
  });

  // quem estava na base e nao veio na planilha nao e apagado — so sinalizado
  antigos.forEach(a => {
    if (usados.has(a.id)) return;
    resumo.ausentes.push(a.nome);
    lista.push({ ...a, ausenteNaUltimaPlanilha: true });
  });

  return { lista, resumo };
}

function parseTextFile(text) {
  const primeira = (text.replace(/\r\n/g, '\n').split('\n').find(l => l.trim() !== '') || '');
  return rowsToClientes(splitDelimited(text, detectDelim(primeira)));
}

async function parseXlsxFile(arrayBuffer) {
  const XLSX = await import('xlsx');
  const wb = XLSX.read(new Uint8Array(arrayBuffer), { type: 'array' });
  const ws = wb.Sheets[wb.SheetNames[0]];
  const rows = XLSX.utils.sheet_to_json(ws, { header: 1, blankrows: false, defval: '' });
  return rowsToClientes(rows.map(r => r.map(c => (c == null ? '' : String(c)))));
}

// ─── Modal Novo/Editar ────────────────────────────────────────────────────────
function ClienteModal({ onClose, onSave, clienteEditando, chamados = [], onNovoChamado, onAbrirChamado, mostrarValor = true }) {
  const editing = !!clienteEditando;
  const [form, setForm] = useState({
    clienteId:             clienteEditando?.clienteId             || '',
    documento:             clienteEditando?.documento             || '',
    nome:                  clienteEditando?.nome                  || '',
    email:                 clienteEditando?.email                 || '',
    telefone:              clienteEditando?.telefone              || '',
    aniversario:           clienteEditando?.aniversario           || '',
    contato:               clienteEditando?.contato               || '',
    observacao:            clienteEditando?.observacao            || '',
    sistemaCobranca:       clienteEditando?.sistemaCobranca       || 'Avec',
    statusContrato:        clienteEditando?.statusContrato        || 'Ativo',
    periodicidadeContrato: clienteEditando?.periodicidadeContrato || 'Mensal',
    ativacaoContrato:      clienteEditando?.ativacaoContrato      || '',
    expiracaoContrato:     clienteEditando?.expiracaoContrato     || '',
    produtos:              clienteEditando ? getProdutos(clienteEditando) : [],
    iaFaixa:               clienteEditando?.iaFaixa               || '',
    iaModulos:             clienteEditando ? getIaModulos(clienteEditando) : [],
    mrrCustom:             (clienteEditando?.mrrCustom ?? '') === '' ? '' : String(clienteEditando.mrrCustom),
  });
  const [dropAdd, setDropAdd] = useState(false);

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const addProduto = (nome) => {
    setForm(p => p.produtos.includes(nome) ? p : { ...p, produtos: [...p.produtos, nome] });
    setDropAdd(false);
  };
  const removeProduto = (nome) => setForm(p => ({ ...p, produtos: p.produtos.filter(n => n !== nome) }));
  const toggleIA = (key) =>
    setForm(p => ({ ...p, iaModulos: p.iaModulos.includes(key) ? p.iaModulos.filter(k => k !== key) : [...p.iaModulos, key] }));

  const faixaAuto = faixaDoPlano(form.produtos);
  const faixaEfetiva = form.iaFaixa || faixaAuto;
  const comboAtivo = ['ci', 'cs', 'cm'].every(k => form.iaModulos.includes(k));

  const mrrCalc = calcMRRCliente(form);
  const negRaw = String(form.mrrCustom).trim();
  const negNum = negRaw === '' ? '' : valorToNumber(negRaw);
  const temNegociado = negNum !== '' && !isNaN(negNum);
  const valorFinal = temNegociado ? negNum : mrrCalc;

  const salvar = () => {
    if (!form.nome.trim()) return;
    onSave({
      id: clienteEditando?.id || Date.now(),
      ...form,
      mrrCustom: temNegociado ? negNum : '',
      // retrocompat de leitura em outras telas:
      nomeContrato: form.produtos[0] || '',
      nomeComponente: form.produtos[1] || '',
    });
    onClose();
  };

  const fmt = (n) => 'R$' + Number(n).toLocaleString('pt-BR', { minimumFractionDigits: 2 });

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
      zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      onMouseDown={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background: '#fff', borderRadius: '16px', padding: '28px',
        width: '580px', maxHeight: '90vh', overflowY: 'auto',
        boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between',
          alignItems: 'center', marginBottom: '22px' }}>
          <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: '18px' }}>
            {editing ? 'Editar cliente' : 'Novo cliente'}
          </h2>
          <button onClick={onClose} style={{ border: 'none', background: 'none',
            fontSize: '22px', cursor: 'pointer', color: '#9898b8' }}>×</button>
        </div>

        <div style={secTitle}>Identificação</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
          <div><label style={lbl}>Cliente ID</label>
            <input value={form.clienteId} onChange={e => set('clienteId', e.target.value)}
              placeholder="Ex: 45821" style={inp} /></div>
          <div><label style={lbl}>Documento (CPF/CNPJ)</label>
            <input value={form.documento} onChange={e => set('documento', e.target.value)}
              placeholder="Ex: 12.345.678/0001-99" style={inp} /></div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
          <div><label style={lbl}>Nome do salão</label>
            <input value={form.nome} onChange={e => set('nome', e.target.value)}
              placeholder="Ex: Studio Bella Vita" style={inp} /></div>
          <div><label style={lbl}>E-mail</label>
            <input type="email" value={form.email} onChange={e => set('email', e.target.value)}
              placeholder="Ex: contato@salao.com" style={inp} /></div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
          <div><label style={lbl}>WhatsApp <span style={{ opacity: .5, textTransform: 'none' }}>(DDD + número)</span></label>
            <input value={form.telefone} onChange={e => set('telefone', e.target.value.replace(/\D/g, ''))}
              placeholder="Ex: 5541999887766" style={{ ...inp, fontFamily: 'monospace' }} /></div>
          <div><label style={lbl}>Aniversário do dono</label>
            <input type="date" value={form.aniversario} onChange={e => set('aniversario', e.target.value)} style={inp} /></div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
          <div><label style={lbl}>Contato <span style={{ opacity: .5, textTransform: 'none' }}>(quem fala com você)</span></label>
            <input value={form.contato} onChange={e => set('contato', e.target.value)} placeholder="Ex: Renata (gerente)" style={inp} /></div>
          <div><label style={lbl}>Observação</label>
            <input value={form.observacao} onChange={e => set('observacao', e.target.value)} placeholder="Ex: quer NFS-e no próximo ciclo" style={inp} /></div>
        </div>
        <div style={{ marginBottom: '20px', maxWidth: '50%', paddingRight: '6px' }}>
          <label style={lbl}>Sistema de Cobrança</label>
          <select value={form.sistemaCobranca} onChange={e => set('sistemaCobranca', e.target.value)}
            style={{ ...inp, cursor: 'pointer' }}>
            <option>Avec</option><option>Asaas</option><option>Outro</option>
          </select>
        </div>

        <div style={secTitle}>Contrato</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
          <div><label style={lbl}>Status</label>
            <select value={form.statusContrato} onChange={e => set('statusContrato', e.target.value)}
              style={{ ...inp, cursor: 'pointer' }}>
              <option>Ativo</option><option>Cancelado</option><option>Suspenso</option><option>Expirado</option>
            </select></div>
          <div><label style={lbl}>Periodicidade</label>
            <select value={form.periodicidadeContrato} onChange={e => set('periodicidadeContrato', e.target.value)}
              style={{ ...inp, cursor: 'pointer' }}>
              <option>Mensal</option><option>Anual</option><option>Avulso</option>
            </select></div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '20px' }}>
          <div><label style={lbl}>Ativação</label>
            <input type="date" value={form.ativacaoContrato} onChange={e => set('ativacaoContrato', e.target.value)}
              style={inp} /></div>
          <div><label style={lbl}>Expiração</label>
            <input type="date" value={form.expiracaoContrato} onChange={e => set('expiracaoContrato', e.target.value)}
              style={inp} /></div>
        </div>

        <div style={secTitle}>Produtos contratados</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '10px' }}>
          {form.produtos.length === 0 && (
            <span style={{ fontSize: '12px', color: '#9898b8', fontStyle: 'italic' }}>Nenhum produto adicionado ainda.</span>
          )}
          {form.produtos.map(nome => {
            const legado = !noCatalogo(nome);
            return (
              <span key={nome} style={{ display: 'inline-flex', alignItems: 'center', gap: '8px',
                padding: '6px 10px', borderRadius: '8px', fontSize: '12px', fontWeight: '600',
                background: legado ? 'rgba(217,119,6,0.08)' : 'rgba(16,185,129,0.08)',
                color: legado ? '#b45309' : '#059669',
                border: '1px solid ' + (legado ? 'rgba(217,119,6,0.25)' : 'rgba(16,185,129,0.2)') }}>
                {nome}{mostrarValor ? ' · ' + (legado ? 'fora do catálogo' : fmt(produtoMRR(nome))) : ''}
                <button onClick={() => removeProduto(nome)} style={{ border: 'none', background: 'none',
                  cursor: 'pointer', color: 'inherit', fontSize: '14px', lineHeight: 1 }}>×</button>
              </span>
            );
          })}
        </div>
        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <button onClick={() => setDropAdd(p => !p)} style={{ ...inp, cursor: 'pointer', textAlign: 'left',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#6c47ff', fontWeight: '600' }}>
            <span>＋ Adicionar produto</span>
            <span style={{ fontSize: '10px' }}>{dropAdd ? '▲' : '▼'}</span>
          </button>
          {dropAdd && (
            <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff',
              border: '1.5px solid rgba(0,0,0,0.1)', borderRadius: '9px', boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
              zIndex: 100, maxHeight: '240px', overflowY: 'auto', marginTop: '4px' }}>
              {[['PLATAFORMA', CATALOGO_PLATAFORMA], ['MÓDULOS', CATALOGO_MODULOS]].map(([grupo, lista]) => (
                <div key={grupo}>
                  <div style={{ padding: '8px 14px 4px', fontSize: '9px', fontWeight: '700', letterSpacing: '1px',
                    color: '#9898b8', fontFamily: 'monospace' }}>{grupo}</div>
                  {lista.map(p => {
                    const jaTem = form.produtos.includes(p.nome);
                    return (
                      <div key={p.nome} onClick={() => !jaTem && addProduto(p.nome)}
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                          padding: '9px 14px', cursor: jaTem ? 'default' : 'pointer', fontSize: '13px',
                          opacity: jaTem ? 0.4 : 1, borderBottom: '1px solid rgba(0,0,0,0.04)' }}
                        onMouseEnter={e => { if (!jaTem) e.currentTarget.style.background = 'rgba(108,71,255,0.06)'; }}
                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                        <span>{p.nome}{jaTem && ' ✓'}</span>
                        {mostrarValor && (
                          <span style={{ fontSize: '11px', color: '#059669', fontFamily: 'monospace', fontWeight: '600' }}>
                            {fmt(p.mrr)}
                          </span>
                        )}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          )}
        </div>

        <div style={secTitle}>Inteligência Artificial</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '12px' }}>
          {IA_MODS.map(m => {
            const sel = form.iaModulos.includes(m.key);
            const f = FAIXAS_IA.find(x => x.l === faixaEfetiva) || FAIXAS_IA[0];
            return (
              <div key={m.key} onClick={() => toggleIA(m.key)} style={{ display: 'flex', alignItems: 'center',
                justifyContent: 'space-between', padding: '10px 14px', borderRadius: '9px', cursor: 'pointer',
                border: sel ? '1.5px solid #6c47ff' : '1.5px solid rgba(0,0,0,0.08)',
                background: sel ? 'rgba(108,71,255,0.05)' : '#f8f8fc' }}>
                <span style={{ fontSize: '13px', fontWeight: '600' }}>{m.ico} {m.nome}</span>
                {mostrarValor && (
                  <span style={{ fontSize: '12px', fontWeight: '700', color: sel ? '#6c47ff' : '#9898b8', fontFamily: 'monospace' }}>
                    {fmt(f[m.key])}
                  </span>
                )}
              </div>
            );
          })}
        </div>
        {form.iaModulos.length > 0 && (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', alignItems: 'center', marginBottom: '12px' }}>
              <div>
                <label style={lbl}>Faixa da IA</label>
                <select value={form.iaFaixa} onChange={e => set('iaFaixa', e.target.value)} style={{ ...inp, cursor: 'pointer' }}>
                  <option value="">Automático (pelo plano: {faixaAuto})</option>
                  {FAIXAS_IA.map(f => <option key={f.l} value={f.l}>{f.l}</option>)}
                </select>
              </div>
              {comboAtivo && (
                <div style={{ background: 'rgba(22,163,74,0.07)', border: '1px solid rgba(22,163,74,0.2)',
                  borderRadius: '9px', padding: '10px 12px', fontSize: '11px', color: '#16a34a', fontWeight: '600' }}>
                  🎉 Combo dos 3 módulos aplicado
                </div>
              )}
            </div>
          </>
        )}

        {mostrarValor && (<>
        <div style={secTitle}>Valor mensal (MRR)</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
          <div>
            <label style={lbl}>MRR calculado (catálogo)</label>
            <div style={{ ...inp, background: '#f0f0f8', display: 'flex', alignItems: 'center',
              color: mrrCalc > 0 ? '#0a0a18' : '#9898b8' }}>{fmt(mrrCalc)}</div>
          </div>
          <div>
            <label style={lbl}>Valor negociado (opcional)</label>
            <input value={form.mrrCustom} onChange={e => set('mrrCustom', e.target.value)}
              placeholder={`Padrão: ${fmt(mrrCalc)}`} inputMode="decimal" style={inp} />
          </div>
        </div>
        <div style={{ marginBottom: '20px', padding: '12px 16px', borderRadius: '10px',
          background: 'rgba(5,150,105,0.06)', border: '1px solid rgba(5,150,105,0.15)',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: '12px', color: '#52526e', fontFamily: 'monospace' }}>
            {temNegociado ? '💬 Valor final (negociado)' : 'Valor final'}
          </span>
          <span style={{ fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: '16px', color: '#059669' }}>
            {fmt(Number(valorFinal))}
          </span>
        </div>
        </>)}

        <ChamadosDoCliente chamados={chamados} podeAbrir={editing}
          onNovo={onNovoChamado} onAbrir={onAbrirChamado} />

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button onClick={onClose} style={btnGhost}>Cancelar</button>
          <button onClick={salvar}
            style={{ background: 'linear-gradient(135deg, #6c47ff, #5535e0)',
              color: '#fff', border: 'none', borderRadius: '10px',
              padding: '10px 24px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}>
            {editing ? 'Salvar alterações' : 'Salvar cliente'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Card ─────────────────────────────────────────────────────────────────────
// Visao em lista: com 500 clientes, 500 cardzoes viram rolagem infinita.
// A linha mostra o essencial e o clique abre o card completo.
function ClienteLinha({ c, onEdit, selecionado, onToggle, chamadosAbertos = 0, mostrarValor = true }) {
  const mrr = mrrEfetivo(c);
  const produtos = getProdutos(c);
  const iaMods = getIaModulos(c);
  const statusColor = { 'Ativo':'#059669','Cancelado':'#dc2626','Suspenso':'#d97706','Expirado':'#9898b8' }[c.statusContrato] || '#9898b8';
  const plano = produtos.find(n => CATALOGO_PLATAFORMA.some(p => p.nome === n));
  const extras = produtos.filter(n => n !== plano);

  return (
    <div onClick={onEdit}
      style={{ display: 'grid',
        gridTemplateColumns: '26px minmax(0,2.2fr) 88px minmax(0,2.6fr)' + (mostrarValor ? ' 96px' : ''),
        alignItems: 'center', gap: '10px', padding: '9px 12px',
        borderTop: '1px solid rgba(0,0,0,0.05)', cursor: 'pointer',
        background: selecionado ? 'rgba(108,71,255,0.05)' : 'transparent' }}
      onMouseEnter={e => e.currentTarget.style.background = selecionado ? 'rgba(108,71,255,0.08)' : 'rgba(0,0,0,0.02)'}
      onMouseLeave={e => e.currentTarget.style.background = selecionado ? 'rgba(108,71,255,0.05)' : 'transparent'}>

      <div onClick={e => e.stopPropagation()}>
        <input type="checkbox" checked={!!selecionado} onChange={onToggle} disabled={!c.telefone}
          title={c.telefone ? 'Selecionar para disparo' : 'Sem WhatsApp cadastrado'}
          style={{ cursor: c.telefone ? 'pointer' : 'not-allowed' }} />
      </div>

      <div style={{ minWidth: 0 }}>
        <div style={{ fontWeight: '600', fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {c.nome}
          {chamadosAbertos > 0 && (
            <span title={`${chamadosAbertos} chamado(s) aberto(s)`}
              style={{ marginLeft: '7px', padding: '1px 7px', borderRadius: '5px', fontSize: '10px',
                fontWeight: '700', fontFamily: 'monospace', background: 'rgba(239,68,68,0.1)', color: '#dc2626' }}>
              🎫 {chamadosAbertos}
            </span>
          )}
        </div>
        <div style={{ fontSize: '11px', color: c.telefone ? '#52526e' : '#b45309', fontFamily: 'monospace',
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {c.telefone ? `📱 ${c.telefone}` : '📱 sem WhatsApp'}
          {c.clienteId && ` · ${c.clienteId}`}
          {c.expiracaoContrato && ` · exp ${c.expiracaoContrato.split('-').reverse().join('/')}`}
        </div>
      </div>

      <div>
        <span style={{ padding: '2px 7px', borderRadius: '5px', fontSize: '10px', fontWeight: '700',
          background: statusColor + '18', color: statusColor, fontFamily: 'monospace' }}>
          {c.statusContrato || '—'}
        </span>
      </div>

      <div style={{ display: 'flex', gap: '4px', flexWrap: 'nowrap', overflow: 'hidden' }}>
        {plano && <Tag cor="#059669">{plano}</Tag>}
        {iaMods.length > 0 && <Tag cor="#6c47ff">🤖 {iaMods.length === 3 ? 'IA Completa' : iaMods.map(k => IA_MODS.find(m => m.key === k)?.nome).join('+')}</Tag>}
        {extras.slice(0, 2).map(n => <Tag key={n} cor="#52526e">{n.replace('NF de Serviço (NFS-e)', 'NFS-e').replace('NF de Produto', 'NFC-e')}</Tag>)}
        {extras.length > 2 && <Tag cor="#9898b8">+{extras.length - 2}</Tag>}
        {!plano && !extras.length && !iaMods.length && <span style={{ fontSize: '11px', color: '#c4c4d4' }}>sem produto</span>}
      </div>

      {mostrarValor && (
        <div style={{ textAlign: 'right', fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: '13px',
          color: mrr > 0 ? '#059669' : '#c4c4d4' }}>
          {mrr > 0 ? 'R$' + mrr.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : '—'}
        </div>
      )}
    </div>
  );
}

function Tag({ cor, children }) {
  return (
    <span style={{ padding: '2px 7px', borderRadius: '5px', fontSize: '10px', fontWeight: '600',
      background: cor + '14', color: cor, whiteSpace: 'nowrap', maxWidth: '100%',
      overflow: 'hidden', textOverflow: 'ellipsis' }}>{children}</span>
  );
}

function ClienteCard({ c, onEdit, selecionado, onToggle, chamadosAbertos = 0, mostrarValor = true }) {
  const mrr = mrrEfetivo(c);
  const negociado = c.mrrCustom !== undefined && c.mrrCustom !== null
    && String(c.mrrCustom).trim() !== '' && !isNaN(valorToNumber(c.mrrCustom));
  const produtos = getProdutos(c);
  const iaMods = getIaModulos(c);
  const statusColor = { 'Ativo':'#059669','Cancelado':'#dc2626','Suspenso':'#d97706','Expirado':'#9898b8' }[c.statusContrato] || '#9898b8';

  return (
    <div onClick={onEdit}
      style={{ background: selecionado ? 'rgba(108,71,255,0.03)' : '#fff', border: '1px solid ' + (selecionado ? 'rgba(108,71,255,0.45)' : 'rgba(0,0,0,0.08)'),
        borderRadius: '14px', padding: '18px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        cursor: 'pointer', transition: 'border-color 0.2s' }}
      onMouseEnter={e => e.currentTarget.style.borderColor = 'rgba(108,71,255,0.3)'}
      onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(0,0,0,0.08)'}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
        <div style={{ flexShrink: 0, marginRight: '10px', paddingTop: '2px' }} onClick={e => e.stopPropagation()}>
          <input type="checkbox" checked={!!selecionado} onChange={onToggle}
            title={c.telefone ? 'Selecionar para disparo' : 'Sem WhatsApp cadastrado'} disabled={!c.telefone}
            style={{ cursor: c.telefone ? 'pointer' : 'not-allowed' }} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '14px',
            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.nome}</div>
          <div style={{ fontSize: '11px', color: '#9898b8', fontFamily: 'monospace', marginTop: '2px' }}>
            {c.clienteId && `ID: ${c.clienteId}`}{c.documento && ` · ${c.documento}`}
          </div>
          {c.email && (
            <div style={{ fontSize: '11px', color: '#9898b8', marginTop: '2px',
              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>✉ {c.email}</div>
          )}
          <div style={{ fontSize: '11px', color: c.telefone ? '#9898b8' : '#d97706', marginTop: '2px', fontFamily: 'monospace' }}>
            {c.telefone ? `📱 ${c.telefone}` : '📱 sem WhatsApp'}
          </div>
        </div>
        {mostrarValor && mrr > 0 && (
          <div style={{ textAlign: 'right', flexShrink: 0, marginLeft: '12px' }}>
            <div style={{ fontSize: '9px', color: '#9898b8', fontFamily: 'monospace' }}>
              MRR{negociado && <span style={{ color: '#6c47ff', fontWeight: '700' }}> · NEG.</span>}
            </div>
            <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: '14px', color: '#059669' }}>
              R${mrr.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
            </div>
          </div>
        )}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', marginBottom: '8px' }}>
        {chamadosAbertos > 0 && (
          <span title={`${chamadosAbertos} chamado(s) aberto(s)`}
            style={{ padding: '2px 8px', borderRadius: '5px', fontSize: '10px', fontWeight: '700',
              background: 'rgba(239,68,68,0.1)', color: '#dc2626', fontFamily: 'monospace' }}>
            🎫 {chamadosAbertos} chamado{chamadosAbertos > 1 ? 's' : ''}
          </span>
        )}
        {c.statusContrato && (
          <span style={{ padding: '2px 8px', borderRadius: '5px', fontSize: '10px', fontWeight: '700',
            background: statusColor + '18', color: statusColor, fontFamily: 'monospace' }}>{c.statusContrato}</span>
        )}
        {c.sistemaCobranca && (
          <span style={{ padding: '2px 8px', borderRadius: '5px', fontSize: '10px',
            background: 'rgba(108,71,255,0.08)', color: '#6c47ff', fontFamily: 'monospace' }}>{c.sistemaCobranca}</span>
        )}
        {c.periodicidadeContrato && (
          <span style={{ padding: '2px 8px', borderRadius: '5px', fontSize: '10px',
            background: 'rgba(0,0,0,0.05)', color: '#52526e', fontFamily: 'monospace' }}>{c.periodicidadeContrato}</span>
        )}
      </div>
      {produtos.map(nome => (
        <div key={nome} style={{ padding: '7px 10px', borderRadius: '7px',
          background: 'rgba(16,185,129,0.07)', fontSize: '11px', color: '#059669',
          fontWeight: '600', marginBottom: '4px' }}>✓ {nome}</div>
      ))}
      {iaMods.length > 0 && (
        <div style={{ padding: '7px 10px', borderRadius: '7px',
          background: 'rgba(108,71,255,0.06)', fontSize: '11px', color: '#6c47ff',
          fontWeight: '600', marginBottom: '4px' }}>
          🤖 IA: {iaMods.length === 3 ? 'Completa (Combo)' : iaMods.map(k => IA_MODS.find(m => m.key === k)?.nome).join(' + ')}
        </div>
      )}
      {(c.ativacaoContrato || c.expiracaoContrato) && (
        <div style={{ fontSize: '10px', color: '#9898b8', fontFamily: 'monospace', marginTop: '6px' }}>
          {c.ativacaoContrato && `Ativação: ${c.ativacaoContrato}`}
          {c.ativacaoContrato && c.expiracaoContrato && ' · '}
          {c.expiracaoContrato && `Exp: ${c.expiracaoContrato}`}
        </div>
      )}
    </div>
  );
}

// ─── Chamados ─────────────────────────────────────────────────────────────────
// Cada chamado é um documento em users/{uid}/chamados — e não um campo dentro
// do blob de clientes. Dois motivos: o blob tem teto de 1 MB (uns 500 clientes
// já ocupam boa parte dele), e documento separado dá pra ordenar a fila por
// urgência sem reescrever a carteira inteira a cada anotação.
const STATUS_CHAMADO = {
  aberto:     { label: 'Aberto',            cor: '#dc2626', bg: 'rgba(239,68,68,0.10)' },
  andamento:  { label: 'Em andamento',      cor: '#d97706', bg: 'rgba(245,158,11,0.12)' },
  aguardando: { label: 'Aguardando cliente', cor: '#6c47ff', bg: 'rgba(108,71,255,0.10)' },
  resolvido:  { label: 'Resolvido',         cor: '#059669', bg: 'rgba(16,185,129,0.10)' },
};
const ABERTOS = ['aberto', 'andamento', 'aguardando'];

const PRIORIDADES = {
  urgente: { label: '🔴 Urgente', cor: '#dc2626', peso: 0 },
  alta:    { label: '🟠 Alta',    cor: '#d97706', peso: 1 },
  normal:  { label: '🔵 Normal',  cor: '#52526e', peso: 2 },
  baixa:   { label: '⚪ Baixa',   cor: '#9898b8', peso: 3 },
};

const CATEGORIAS = ['Dúvida de uso', 'Problema técnico', 'Financeiro / cobrança',
                    'Treinamento', 'Agenda / IA', 'Fiscal (NF)', 'Migração de dados', 'Outro'];

const agoraISO = () => new Date().toISOString();

// Identidade do cliente no chamado: o id local é o que sobrevive à reimportação
// (mesclarClientes preserva o id de quem já existia). Nome e documento vão junto
// só para o chamado continuar legível se o cliente for apagado da carteira.
const refDoCliente = (c) => String(c?.id ?? '');

const chamadoToFields = (ch) => ({
  clienteRef:    { stringValue: String(ch.clienteRef || '') },
  clienteNome:   { stringValue: ch.clienteNome || '' },
  clienteDoc:    { stringValue: ch.clienteDoc || '' },
  titulo:        { stringValue: ch.titulo || '' },
  descricao:     { stringValue: ch.descricao || '' },
  status:        { stringValue: ch.status || 'aberto' },
  prioridade:    { stringValue: ch.prioridade || 'normal' },
  categoria:     { stringValue: ch.categoria || '' },
  responsavel:   { stringValue: ch.responsavel || '' },
  criadoEm:      { stringValue: ch.criadoEm || agoraISO() },
  atualizadoEm:  { stringValue: agoraISO() },
  resolvidoEm:   { stringValue: ch.resolvidoEm || '' },
  historicoJson: { stringValue: JSON.stringify(ch.historico || []) },
});

const docToChamado = (d) => {
  const f = d.fields || {};
  const s = (k) => f[k]?.stringValue || '';
  let historico = [];
  try { historico = JSON.parse(s('historicoJson') || '[]'); } catch { historico = []; }
  return {
    id: String(d.name || '').split('/').pop(),
    clienteRef: s('clienteRef'), clienteNome: s('clienteNome'), clienteDoc: s('clienteDoc'),
    titulo: s('titulo'), descricao: s('descricao'),
    status: s('status') || 'aberto', prioridade: s('prioridade') || 'normal',
    categoria: s('categoria'), responsavel: s('responsavel'),
    criadoEm: s('criadoEm'), atualizadoEm: s('atualizadoEm'), resolvidoEm: s('resolvidoEm'),
    historico,
  };
};

const chamadoVazio = (cliente) => ({
  id: '', clienteRef: cliente ? refDoCliente(cliente) : '',
  clienteNome: cliente?.nome || '', clienteDoc: cliente?.clienteId || cliente?.documento || '',
  titulo: '', descricao: '', status: 'aberto', prioridade: 'normal',
  categoria: '', responsavel: '', criadoEm: '', resolvidoEm: '', historico: [],
});

const fmtDataHora = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return isNaN(d) ? '' : d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
};

// "há 3 dias" diz mais que uma data: o que importa num chamado é há quanto
// tempo ele está parado.
const idadeEmTexto = (iso) => {
  if (!iso) return '';
  const ms = Date.now() - new Date(iso).getTime();
  if (isNaN(ms) || ms < 0) return '';
  const min = Math.floor(ms / 60000);
  if (min < 60) return `há ${min || 1} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `há ${h}h`;
  const dias = Math.floor(h / 24);
  return dias === 1 ? 'há 1 dia' : `há ${dias} dias`;
};
const diasParados = (iso) => {
  const ms = Date.now() - new Date(iso || Date.now()).getTime();
  return isNaN(ms) ? 0 : Math.floor(ms / 86400000);
};

function TagStatus({ status }) {
  const s = STATUS_CHAMADO[status] || STATUS_CHAMADO.aberto;
  return (
    <span style={{ padding: '2px 8px', borderRadius: '5px', fontSize: '10px', fontWeight: '700',
      background: s.bg, color: s.cor, fontFamily: 'monospace', whiteSpace: 'nowrap' }}>{s.label}</span>
  );
}

// ─── Modal de chamado (criar, editar, excluir) ────────────────────────────────
function ChamadoModal({ chamado, clientes, onClose, onSalvar, onExcluir }) {
  const editando = !!chamado.id;
  const [f, setF] = useState({ ...chamado });
  const [nota, setNota] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));

  // Chamado aberto pela fila ainda não tem dono: escolhe aqui.
  const precisaEscolherCliente = !f.clienteRef;
  const clientesOrdenados = [...clientes].sort((a, b) =>
    (a.statusContrato === 'Ativo' ? 0 : 1) - (b.statusContrato === 'Ativo' ? 0 : 1)
    || String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR'));

  const escolherCliente = (id) => {
    const c = clientes.find(x => String(x.id) === String(id));
    if (!c) { setF(p => ({ ...p, clienteRef: '', clienteNome: '', clienteDoc: '' })); return; }
    setF(p => ({ ...p, clienteRef: refDoCliente(c), clienteNome: c.nome, clienteDoc: c.clienteId || c.documento || '' }));
  };

  const salvar = async () => {
    if (!f.titulo.trim())  { setErro('Dê um assunto ao chamado.'); return; }
    if (!f.clienteRef)     { setErro('Escolha de qual cliente é o chamado.'); return; }
    setSalvando(true); setErro('');
    const historico = [...(f.historico || [])];
    if (nota.trim()) historico.unshift({ texto: nota.trim(), em: agoraISO(), autor: f.responsavel || '' });
    // marca a hora da resolução na primeira vez que vira resolvido
    const resolvidoEm = f.status === 'resolvido' ? (f.resolvidoEm || agoraISO()) : '';
    try {
      await onSalvar({ ...f, historico, resolvidoEm, criadoEm: f.criadoEm || agoraISO() });
      onClose();
    } catch (e) {
      setErro('Não consegui salvar: ' + (e?.message || e));
      setSalvando(false);
    }
  };

  const excluir = async () => {
    if (!window.confirm('Excluir este chamado? Não dá para desfazer.')) return;
    setSalvando(true);
    try { await onExcluir(f.id); onClose(); }
    catch (e) { setErro('Não consegui excluir: ' + (e?.message || e)); setSalvando(false); }
  };

  const hist = Array.isArray(f.historico) ? f.historico : [];
  // telefone vem da carteira, não do chamado: se o cadastro for corrigido,
  // o botão passa a valer para os chamados antigos também
  const donoDoChamado = clientes.find(c => refDoCliente(c) === f.clienteRef);
  const zap = String(donoDoChamado?.telefone || '').replace(/\D/g, '');

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 300,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}
      onMouseDown={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background: '#fff', borderRadius: '16px', padding: '28px', width: '620px',
        maxWidth: '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
          <div>
            <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: '18px' }}>
              {editando ? 'Chamado' : 'Novo chamado'}
            </h2>
            <div style={{ fontSize: '11px', color: '#9898b8', fontFamily: 'monospace', marginTop: '4px' }}>
              {f.clienteNome || 'sem cliente'}
              {editando && f.criadoEm && ` · aberto ${fmtDataHora(f.criadoEm)} (${idadeEmTexto(f.criadoEm)})`}
            </div>
          </div>
          <button onClick={onClose} style={{ border: 'none', background: 'none', fontSize: '22px',
            cursor: 'pointer', color: '#9898b8' }}>×</button>
        </div>

        {precisaEscolherCliente && (
          <div style={{ marginBottom: '14px' }}>
            <label style={lbl}>Cliente</label>
            <select value={f.clienteRef} onChange={e => escolherCliente(e.target.value)}
              style={{ ...inp, cursor: 'pointer' }}>
              <option value="">Escolha o cliente...</option>
              {clientesOrdenados.map(c => (
                <option key={c.id} value={String(c.id)}>
                  {c.nome}{c.statusContrato !== 'Ativo' ? ` (${c.statusContrato})` : ''}
                </option>
              ))}
            </select>
          </div>
        )}

        <div style={{ marginBottom: '14px' }}>
          <label style={lbl}>Assunto</label>
          <input value={f.titulo} onChange={e => set('titulo', e.target.value)} autoFocus
            placeholder="Ex: Agenda não está enviando confirmação" style={inp} />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '14px' }}>
          <div><label style={lbl}>Status</label>
            <select value={f.status} onChange={e => set('status', e.target.value)} style={{ ...inp, cursor: 'pointer' }}>
              {Object.entries(STATUS_CHAMADO).map(([k, s]) => <option key={k} value={k}>{s.label}</option>)}
            </select></div>
          <div><label style={lbl}>Prioridade</label>
            <select value={f.prioridade} onChange={e => set('prioridade', e.target.value)} style={{ ...inp, cursor: 'pointer' }}>
              {Object.entries(PRIORIDADES).map(([k, p]) => <option key={k} value={k}>{p.label}</option>)}
            </select></div>
          <div><label style={lbl}>Categoria</label>
            <select value={f.categoria} onChange={e => set('categoria', e.target.value)} style={{ ...inp, cursor: 'pointer' }}>
              <option value="">—</option>
              {CATEGORIAS.map(c => <option key={c} value={c}>{c}</option>)}
            </select></div>
        </div>

        <div style={{ marginBottom: '14px' }}>
          <label style={lbl}>Responsável <span style={{ opacity: .5, textTransform: 'none' }}>(quem está cuidando)</span></label>
          <input value={f.responsavel} onChange={e => set('responsavel', e.target.value)}
            placeholder="Ex: Marina (suporte)" style={inp} />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={lbl}>O que o cliente relatou</label>
          <textarea value={f.descricao} onChange={e => set('descricao', e.target.value)} rows={4}
            placeholder="Descreva o problema com as palavras do cliente, e o que já foi tentado."
            style={{ ...inp, resize: 'vertical', fontFamily: 'DM Sans, sans-serif' }} />
        </div>

        <div style={{ borderTop: '1px solid rgba(0,0,0,0.07)', paddingTop: '16px', marginBottom: '16px' }}>
          <label style={lbl}>Andamento</label>
          <textarea value={nota} onChange={e => setNota(e.target.value)} rows={2}
            placeholder="O que aconteceu agora? (vira um registro com data ao salvar)"
            style={{ ...inp, resize: 'vertical', fontFamily: 'DM Sans, sans-serif', marginTop: '6px' }} />
          {hist.length > 0 && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '12px' }}>
              {hist.map((h, i) => (
                <div key={i} style={{ background: '#f8f8fc', borderRadius: '9px', padding: '10px 12px' }}>
                  <div style={{ fontSize: '10px', color: '#6b6b85', fontFamily: 'monospace', marginBottom: '3px' }}>
                    {fmtDataHora(h.em)}{h.autor ? ` · ${h.autor}` : ''}
                  </div>
                  <div style={{ fontSize: '13px', color: '#0a0a18', whiteSpace: 'pre-wrap' }}>{h.texto}</div>
                </div>
              ))}
            </div>
          )}
        </div>

        {erro && (
          <div style={{ background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)',
            borderRadius: '10px', padding: '12px 14px', marginBottom: '14px', fontSize: '12.5px', color: '#dc2626' }}>
            ⚠ {erro}
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px' }}>
          <div>
            {editando && (
              <button onClick={excluir} disabled={salvando}
                style={{ ...btnGhost, color: '#dc2626', borderColor: 'rgba(220,38,38,0.3)' }}>Excluir</button>
            )}
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            {zap.length >= 10 && (
              <a href={`https://wa.me/${zap}`} target="_blank" rel="noreferrer"
                style={{ ...btnGhost, textDecoration: 'none', display: 'inline-block',
                  color: '#059669', borderColor: 'rgba(5,150,105,0.35)' }}>Abrir WhatsApp</a>
            )}
            {editando && f.status !== 'resolvido' && (
              <button onClick={() => set('status', 'resolvido')} disabled={salvando}
                style={{ ...btnGhost, color: '#059669', borderColor: 'rgba(5,150,105,0.35)' }}>✓ Marcar resolvido</button>
            )}
            <button onClick={onClose} style={btnGhost}>Cancelar</button>
            <button onClick={salvar} disabled={salvando}
              style={{ background: salvando ? '#9898b8' : 'linear-gradient(135deg, #6c47ff, #5535e0)',
                color: '#fff', border: 'none', borderRadius: '10px', padding: '10px 24px',
                fontSize: '14px', fontWeight: '600', cursor: salvando ? 'not-allowed' : 'pointer' }}>
              {salvando ? 'Salvando...' : editando ? 'Salvar' : 'Abrir chamado'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Lista de chamados dentro do cadastro do cliente ──────────────────────────
function ChamadosDoCliente({ chamados, podeAbrir, onNovo, onAbrir }) {
  const abertos = chamados.filter(c => ABERTOS.includes(c.status));
  const fechados = chamados.filter(c => !ABERTOS.includes(c.status));
  const lista = [...abertos, ...fechados];

  return (
    <>
      <div style={{ ...secTitle, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Chamados {chamados.length > 0 && `· ${abertos.length} aberto${abertos.length === 1 ? '' : 's'}`}</span>
        {podeAbrir && (
          <button onClick={onNovo} style={{ border: 'none', background: 'none', cursor: 'pointer',
            color: '#6c47ff', fontSize: '11px', fontWeight: '700', fontFamily: 'monospace',
            textTransform: 'uppercase', letterSpacing: '0.06em' }}>＋ Novo chamado</button>
        )}
      </div>

      {!podeAbrir ? (
        <div style={{ fontSize: '12px', color: '#9898b8', fontStyle: 'italic', marginBottom: '20px' }}>
          Salve o cliente primeiro — aí o botão de abrir chamado aparece aqui.
        </div>
      ) : lista.length === 0 ? (
        <div style={{ fontSize: '12px', color: '#9898b8', fontStyle: 'italic', marginBottom: '20px' }}>
          Nenhum chamado para este cliente.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '20px' }}>
          {lista.map(ch => (
            <div key={ch.id} onClick={() => onAbrir(ch)}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px',
                padding: '10px 12px', borderRadius: '9px', cursor: 'pointer',
                background: ABERTOS.includes(ch.status) ? '#f8f8fc' : 'transparent',
                border: '1px solid rgba(0,0,0,0.07)',
                opacity: ABERTOS.includes(ch.status) ? 1 : 0.6 }}
              onMouseEnter={e => e.currentTarget.style.borderColor = 'rgba(108,71,255,0.35)'}
              onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(0,0,0,0.07)'}>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: '13px', fontWeight: '600', overflow: 'hidden',
                  textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{ch.titulo}</div>
                <div style={{ fontSize: '10px', color: '#9898b8', fontFamily: 'monospace', marginTop: '2px' }}>
                  {idadeEmTexto(ch.criadoEm)}{ch.categoria ? ` · ${ch.categoria}` : ''}
                  {ch.responsavel ? ` · ${ch.responsavel}` : ''}
                  {ch.historico?.length ? ` · ${ch.historico.length} registro${ch.historico.length === 1 ? '' : 's'}` : ''}
                </div>
              </div>
              <div style={{ display: 'flex', gap: '5px', alignItems: 'center', flexShrink: 0 }}>
                {ABERTOS.includes(ch.status) && ch.prioridade !== 'normal' && (
                  <span style={{ fontSize: '10px', fontWeight: '700',
                    color: PRIORIDADES[ch.prioridade]?.cor }}>{PRIORIDADES[ch.prioridade]?.label}</span>
                )}
                <TagStatus status={ch.status} />
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}

// ─── Fila de chamados (a aba do suporte) ──────────────────────────────────────
// Ordem: prioridade primeiro, depois quem está esperando há mais tempo. É a
// mesma lógica de qualquer fila de atendimento — quem decide o que fazer agora
// não deveria precisar ler a lista inteira.
function FilaChamados({ chamados, clientes, onNovo, onAbrir }) {
  const [verStatus, setVerStatus] = useState('abertos');
  const [busca, setBusca] = useState('');

  const porStatus = chamados.filter(ch =>
    verStatus === 'todos' ? true
    : verStatus === 'abertos' ? ABERTOS.includes(ch.status)
    : ch.status === verStatus);

  const b = busca.trim().toLowerCase();
  const filtrados = !b ? porStatus : porStatus.filter(ch =>
    [ch.titulo, ch.clienteNome, ch.descricao, ch.responsavel, ch.categoria]
      .some(v => String(v || '').toLowerCase().includes(b)));

  const ordenados = [...filtrados].sort((x, y) => {
    const abertoX = ABERTOS.includes(x.status), abertoY = ABERTOS.includes(y.status);
    if (abertoX !== abertoY) return abertoX ? -1 : 1;
    const px = PRIORIDADES[x.prioridade]?.peso ?? 2, py = PRIORIDADES[y.prioridade]?.peso ?? 2;
    if (px !== py) return px - py;
    return String(x.criadoEm || '').localeCompare(String(y.criadoEm || ''));
  });

  const contar = (k) => k === 'abertos' ? chamados.filter(c => ABERTOS.includes(c.status)).length
                      : k === 'todos' ? chamados.length
                      : chamados.filter(c => c.status === k).length;

  const parados = chamados.filter(c => ABERTOS.includes(c.status) && diasParados(c.criadoEm) >= 7).length;

  return (
    <>
      <div style={{ display: 'flex', gap: '10px', marginBottom: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
        <input value={busca} onChange={e => setBusca(e.target.value)}
          placeholder="Buscar por cliente, assunto ou responsável..."
          style={{ ...inp, flex: 1, minWidth: '240px' }} />
        <div style={{ display: 'flex', gap: '4px', background: '#f0f0f7', padding: '3px', borderRadius: '9px' }}>
          {[['abertos', 'Abertos'], ['resolvido', 'Resolvidos'], ['todos', 'Todos']].map(([k, l]) => (
            <button key={k} onClick={() => setVerStatus(k)} style={{
              background: verStatus === k ? '#fff' : 'transparent',
              color: verStatus === k ? '#0a0a18' : '#52526e', border: 'none', borderRadius: '7px',
              padding: '8px 14px', fontSize: '12px', fontWeight: '600', cursor: 'pointer',
              fontFamily: 'DM Sans, sans-serif',
              boxShadow: verStatus === k ? '0 1px 2px rgba(0,0,0,0.08)' : 'none' }}>
              {l} <span style={{ color: '#9898b8', fontFamily: 'monospace' }}>{contar(k)}</span>
            </button>
          ))}
        </div>
        <button onClick={() => onNovo(null)}
          style={{ background: 'linear-gradient(135deg, #6c47ff, #5535e0)', color: '#fff', border: 'none',
            borderRadius: '10px', padding: '11px 22px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
          + Novo chamado
        </button>
      </div>

      {parados > 0 && verStatus === 'abertos' && (
        <div style={{ background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.3)',
          borderRadius: '10px', padding: '12px 16px', marginBottom: '14px', fontSize: '13px', color: '#92400e' }}>
          ⏳ <strong>{parados}</strong> chamado{parados === 1 ? '' : 's'} aberto{parados === 1 ? '' : 's'} há mais de 7 dias.
        </div>
      )}

      {ordenados.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#9898b8' }}>
          <div style={{ fontSize: '40px', marginBottom: '12px' }}>🎫</div>
          <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '16px', marginBottom: '6px' }}>
            {chamados.length === 0 ? 'Nenhum chamado ainda' : 'Nada com esse filtro'}
          </div>
          <div style={{ fontSize: '13px' }}>
            {chamados.length === 0
              ? 'Abra o primeiro pelo botão acima, ou de dentro do cadastro de um cliente.'
              : 'Troque o filtro ou limpe a busca.'}
          </div>
        </div>
      ) : (
        <div style={{ background: '#fff', border: '1px solid rgba(0,0,0,0.08)', borderRadius: '12px',
          overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '70px minmax(0,2.4fr) minmax(0,1.6fr) 130px 92px',
            gap: '10px', padding: '9px 14px', background: '#f8f8fc', fontSize: '10px', fontFamily: 'monospace',
            fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.06em', color: '#52526e' }}>
            <span>Prior.</span><span>Chamado</span><span>Cliente</span><span>Status</span>
            <span style={{ textAlign: 'right' }}>Aberto</span>
          </div>
          {ordenados.map(ch => {
            const velho = ABERTOS.includes(ch.status) && diasParados(ch.criadoEm) >= 7;
            return (
              <div key={ch.id} onClick={() => onAbrir(ch)}
                style={{ display: 'grid', gridTemplateColumns: '70px minmax(0,2.4fr) minmax(0,1.6fr) 130px 92px',
                  gap: '10px', alignItems: 'center', padding: '10px 14px', cursor: 'pointer',
                  borderTop: '1px solid rgba(0,0,0,0.05)',
                  opacity: ABERTOS.includes(ch.status) ? 1 : 0.55 }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,0,0,0.02)'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                <span style={{ fontSize: '11px', fontWeight: '700', color: PRIORIDADES[ch.prioridade]?.cor }}>
                  {PRIORIDADES[ch.prioridade]?.label || '—'}
                </span>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: '13px', fontWeight: '600', overflow: 'hidden',
                    textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{ch.titulo}</div>
                  <div style={{ fontSize: '10px', color: '#9898b8', fontFamily: 'monospace', marginTop: '2px' }}>
                    {ch.categoria || 'sem categoria'}{ch.responsavel ? ` · ${ch.responsavel}` : ''}
                    {ch.historico?.length ? ` · ${ch.historico.length} reg.` : ''}
                  </div>
                </div>
                <div style={{ fontSize: '12px', color: '#52526e', overflow: 'hidden',
                  textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{ch.clienteNome || '—'}</div>
                <div><TagStatus status={ch.status} /></div>
                <div style={{ textAlign: 'right', fontSize: '11px', fontFamily: 'monospace',
                  color: velho ? '#b45309' : '#9898b8', fontWeight: velho ? '700' : '400' }}>
                  {idadeEmTexto(ch.criadoEm)}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}

// ─── Página ───────────────────────────────────────────────────────────────────
export default function Clientes() {
  // user = quem está logado · contaUid = de quem são os dados.
  // pode() decide o que este papel enxerga dentro da própria tela.
  const { user, contaUid, papel, pode }       = useAuth();
  // suporte não enxerga dinheiro: nem valor negociado, nem totais da carteira
  const podeValores = pode('financeiro');
  const [clientes,        setClientes]        = useState([]);
  const [loading,         setLoading]         = useState(true);
  const [modal,           setModal]           = useState(false);
  const [clienteEditando, setClienteEditando] = useState(null);
  const [busca,           setBusca]           = useState('');
  const [filtro,          setFiltro]          = useState('');
  const [visao,           setVisao]           = useState(() => localStorage.getItem('clientes_visao') || 'lista');
  const [ordem,           setOrdem]           = useState(() => localStorage.getItem('clientes_ordem') || 'nome');
  const trocarVisao = (v) => { setVisao(v); localStorage.setItem('clientes_visao', v); };
  const trocarOrdem = (v) => { setOrdem(v); localStorage.setItem('clientes_ordem', v); };
  const [selected,        setSelected]        = useState(() => new Set()); // ids selecionados p/ disparo
  const { setParaDisparo } = useLeads();
  const navigate = useNavigate();
  const [uploading,       setUploading]       = useState(false);
  const [salvando,        setSalvando]        = useState(false);
  const [exportando,      setExportando]      = useState(false);
  const [chamados,        setChamados]        = useState([]);
  const [aba,             setAba]             = useState('clientes'); // clientes | chamados
  const [chamadoAberto,   setChamadoAberto]   = useState(null);       // objeto do chamado em edição
  const fileRef = useRef();

  useEffect(() => {
    if (!user || !contaUid) return;
    (async () => {
      try {
        const token = await user.getIdToken();
        const doc   = await fsGet(`users/${contaUid}/clientes/dados`, token);
        let lista   = doc ? docToClientes(doc) : [];

        // quem não enxerga valor simplesmente não pede o documento deles
        if (podeValores) {
          const dv = await fsGet(`users/${contaUid}/financeiro/valores`, token);
          let valores = docToValores(dv);

          // migração automática: base antiga ainda guarda o valor dentro da
          // carteira. Na primeira abertura de quem pode ver, muda de lugar.
          const temInline = lista.some(c => c.mrrCustom !== undefined
            && c.mrrCustom !== null && String(c.mrrCustom).trim() !== '');
          if (temInline) {
            const { limpos, valores: doInline } = separarValores(lista);
            valores = { ...doInline, ...valores };   // o que já estava fora manda
            await fsSet(`users/${contaUid}/financeiro/valores`, valoresToFields(valores), token);
            await fsSet(`users/${contaUid}/clientes/dados`, clientesToFields(limpos), token);
            lista = limpos;
          }
          lista = juntarValores(lista, valores);
        }
        setClientes(lista);
        // chamados vêm de uma coleção à parte — se as regras ainda não liberarem,
        // a carteira continua abrindo normalmente.
        const docsCh = await fsList(`users/${contaUid}/chamados`, token);
        setChamados(docsCh.map(docToChamado));
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    })();
  }, [user, contaUid]);

  // ── CRUD de chamados ──
  const salvarChamado = async (ch) => {
    const token = await user.getIdToken();
    if (ch.id) {
      await fsPatch(`users/${contaUid}/chamados/${ch.id}`, chamadoToFields(ch), token);
      setChamados(prev => prev.map(x => x.id === ch.id ? { ...ch, atualizadoEm: agoraISO() } : x));
    } else {
      const criado = await fsCreate(`users/${contaUid}/chamados`, chamadoToFields(ch), token);
      setChamados(prev => [...prev, docToChamado(criado)]);
      registrar(contaUid, { user, papel, acao: 'chamado.abriu', alvo: ch.clienteNome,
        detalhe: `abriu "${ch.titulo}" para ${ch.clienteNome}` });
    }
  };

  const excluirChamado = async (id) => {
    const token = await user.getIdToken();
    const apagado = chamados.find(x => x.id === id);
    await fsDelete(`users/${contaUid}/chamados/${id}`, token);
    setChamados(prev => prev.filter(x => x.id !== id));
    registrar(contaUid, { user, papel, acao: 'chamado.excluiu', alvo: apagado?.clienteNome || '',
      detalhe: `excluiu o chamado "${apagado?.titulo || id}"` });
  };

  const chamadosDoCliente = (c) => chamados.filter(ch => ch.clienteRef === refDoCliente(c));

  const persistir = async (lista) => {
    if (!user || !contaUid) return;
    setSalvando(true);
    try {
      const token = await user.getIdToken();
      // a carteira vai SEM valor; o valor vai para o documento dele. Quem não
      // pode ver valores tem a lista sem eles em memória, então separarValores
      // devolve {} e nada do financeiro é tocado.
      const { limpos, valores } = separarValores(lista);
      await fsSet(`users/${contaUid}/clientes/dados`, clientesToFields(limpos), token);
      if (!podeValores) return;
      await fsSet(`users/${contaUid}/financeiro/valores`, valoresToFields(valores), token);

      // Snapshot carrega MRR: só grava quem enxerga valor, senão o histórico
      // zeraria toda vez que o suporte editasse um telefone.
      const mes      = mesAtual();
      const mrrTotal = lista.reduce((s, c) => s + mrrEfetivo(c), 0);
      const ativos   = lista.filter(c => c.statusContrato === 'Ativo').length;
      await fsSet(`users/${contaUid}/snapshots/${mes}`, {
        mes:      { stringValue: mes },
        mrr:      { doubleValue: mrrTotal },
        total:    { integerValue: lista.length },
        ativos:   { integerValue: ativos },
        clientes: { stringValue: JSON.stringify(lista) },
        savedAt:  { stringValue: new Date().toISOString() },
      }, token);
    } catch (e) { console.error(e); }
    finally { setSalvando(false); }
  };

  const salvarCliente = async (c) => {
    const existia = clientes.some(x => x.id === c.id);
    const nova = (() => {
      const idx = clientes.findIndex(x => x.id === c.id);
      if (idx >= 0) { const arr = [...clientes]; arr[idx] = c; return arr; }
      return [...clientes, c];
    })();
    setClientes(nova);
    await persistir(nova);
    registrar(contaUid, { user, papel,
      acao: existia ? 'cliente.editou' : 'cliente.criou', alvo: c.nome || '',
      detalhe: `${existia ? 'editou' : 'cadastrou'} ${c.nome}` });
  };

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    const nome = file.name.toLowerCase();
    const ehXlsx = nome.endsWith('.xlsx') || nome.endsWith('.xls');
    const reader = new FileReader();
    reader.onload = async (ev) => {
      try {
        const novos = ehXlsx ? await parseXlsxFile(ev.target.result) : parseTextFile(ev.target.result);
        if (novos.length > 0) {
          const { lista, resumo } = mesclarClientes(clientes, novos);
          const antes = clientes.length;
          setClientes(lista);
          await persistir(lista);
          registrar(contaUid, { user, papel, acao: 'carteira.importou', alvo: file.name,
            detalhe: `importou ${file.name}: ${resumo.novos} novos, ${resumo.atualizados} atualizados (base ${antes} → ${lista.length})` });
          const linhas = [
            `✅ ${novos.length} clientes na planilha`,
            `• ${resumo.novos} novos`,
            `• ${resumo.atualizados} atualizados (WhatsApp, e-mail e aniversário preservados)`,
          ];
          if (resumo.viraramChurn.length) linhas.push(`• ${resumo.viraramChurn.length} saíram de Ativo: ${resumo.viraramChurn.slice(0, 8).join(', ')}${resumo.viraramChurn.length > 8 ? '...' : ''}`);
          if (resumo.reativados.length)   linhas.push(`• ${resumo.reativados.length} reativados: ${resumo.reativados.slice(0, 8).join(', ')}${resumo.reativados.length > 8 ? '...' : ''}`);
          if (resumo.ausentes.length)     linhas.push(`• ${resumo.ausentes.length} da sua base não vieram na planilha (mantidos, nada foi apagado)`);
          alert(linhas.join('\n'));
        } else {
          alert('⚠️ Nenhum cliente encontrado. Confira se a primeira linha tem os cabeçalhos e existe uma coluna "Nome".');
        }
      } catch (err) {
        const msg = /Failed to (fetch|resolve)|import|xlsx/i.test(String(err?.message))
          ? '⚠️ Para importar XLSX é preciso instalar a biblioteca: rode "npm install xlsx" no projeto.'
          : ('⚠️ Erro ao ler o arquivo: ' + (err?.message || err));
        alert(msg);
      } finally {
        setUploading(false);
      }
    };
    if (ehXlsx) reader.readAsArrayBuffer(file);
    else reader.readAsText(file, 'UTF-8');
    e.target.value = '';
  };

  const temFiscal = (c) => getProdutos(c).some(n => /^NF de /.test(n));
  const filtrados  = clientes.filter(c => {
    const bate = !busca ||
      c.nome?.toLowerCase().includes(busca.toLowerCase()) ||
      c.clienteId?.includes(busca) || c.documento?.includes(busca) ||
      c.email?.toLowerCase().includes(busca.toLowerCase());
    if (!bate) return false;
    if (!filtro) return true;
    if (filtro === '__sem_fiscal')   return !temFiscal(c);
    if (filtro === '__sem_ia')       return getIaModulos(c).length === 0;
    if (filtro === '__com_ia')       return getIaModulos(c).length > 0;
    if (filtro === '__sem_maquininha') return !temMaquininha(c);
    if (filtro === '__sem_whatsapp') return !c.telefone;
    if (filtro === '__com_whatsapp') return !!c.telefone;
    if (filtro === '__aniversario')  return !!c.aniversario;
    if (filtro.startsWith('tem:'))   return getProdutos(c).includes(filtro.slice(4));
    if (filtro.startsWith('nao:'))   return !getProdutos(c).includes(filtro.slice(4));
    if (filtro.startsWith('temia:')) return getIaModulos(c).includes(filtro.slice(6));
    if (filtro.startsWith('naoia:')) return !getIaModulos(c).includes(filtro.slice(6));
    return getProdutos(c).includes(filtro);
  });
  const ORDENADORES = {
    nome:  (a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR'),
    mrr:   (a, b) => mrrEfetivo(b) - mrrEfetivo(a),
    exp:   (a, b) => (a.expiracaoContrato || '9999').localeCompare(b.expiracaoContrato || '9999'),
    status:(a, b) => String(a.statusContrato || '').localeCompare(String(b.statusContrato || '')),
  };
  const ordenados = [...filtrados].sort(ORDENADORES[ordem] || ORDENADORES.nome);

  // Quando o filtro e "nao tem X", da pra somar quanto esse grupo valeria se
  // fechasse — vira argumento comercial em vez de so uma lista.
  const alvoOferta = filtro === '__sem_maquininha' ? null
                   : filtro.startsWith('nao:') ? ['produto', filtro.slice(4)]
                   : filtro.startsWith('naoia:') ? ['ia', filtro.slice(6)]
                   : filtro === '__sem_ia' ? ['ia-combo', null] : null;
  const ativosDoFiltro = ordenados.filter(c => c.statusContrato === 'Ativo');
  const potencial = !alvoOferta ? 0 : ativosDoFiltro.reduce((soma, c) => {
    const faixa = c.iaFaixa || faixaDoPlanoOuNull(getProdutos(c));
    if (alvoOferta[0] === 'produto')  return soma + (produtoMRR(alvoOferta[1]) || 0);
    if (!faixa) return soma;  // sem plano identificado nao entra na conta da IA
    if (alvoOferta[0] === 'ia')       return soma + mrrIA([alvoOferta[1]], faixa);
    return soma + mrrIA(['ci', 'cs', 'cm'], faixa);
  }, 0);

  const comTelefone = (l) => l.filter(c => c.telefone);

  // Oportunidades: em vez de esperar o franqueado descobrir o filtro, a tela
  // calcula sozinha quanto cada modulo que falta vale e mostra na frente dele.
  // So modulos e IA entram — plano e exclusivo, "sem Ate 10 Prof." pegaria todo mundo.
  const ativos_ = clientes.filter(c => c.statusContrato === 'Ativo');
  const temMaquininha = (c) => Number(c.tpvMes) > 0 || /maquininha/i.test(c.observacao || '');

  // Ordem pelo que o franqueado realmente vende, nao pelo maior numero bruto.
  // SMS ficou de fora de proposito: hoje ninguem vende.
  const PRIORIDADE = { ia: 1, 'NF de Serviço (NFS-e)': 2, 'NF de Produto': 2, maquininha: 3,
                       'Módulo Franquia': 4, 'White Label (manutenção)': 5 };
  const OFERTAVEIS = CATALOGO_MODULOS.filter(p => PRIORIDADE[p.nome]);

  const alvoMaquininha = ativos_.filter(c => !temMaquininha(c));
  const oportunidades = [
    ...IA_MODS.map(m => {
      const alvo = ativos_.filter(c => !getIaModulos(c).includes(m.key));
      const comFaixa = alvo.filter(c => c.iaFaixa || faixaDoPlanoOuNull(getProdutos(c)));
      return {
        chave: 'naoia:' + m.key, label: 'IA ' + m.nome, qtd: alvo.length,
        comZap: comTelefone(alvo).length, prio: PRIORIDADE.ia,
        // o preco da IA muda por faixa: soma o valor da faixa de cada cliente
        valor: comFaixa.reduce((s, c) => s + mrrIA([m.key], c.iaFaixa || faixaDoPlanoOuNull(getProdutos(c))), 0),
        semFaixa: alvo.length - comFaixa.length,
      };
    }),
    ...OFERTAVEIS.map(p => {
      const alvo = ativos_.filter(c => !getProdutos(c).includes(p.nome));
      return { chave: 'nao:' + p.nome, label: p.nome, qtd: alvo.length,
               comZap: comTelefone(alvo).length, prio: PRIORIDADE[p.nome],
               valor: alvo.length * p.mrr, semFaixa: 0 };
    }),
    { chave: '__sem_maquininha', label: 'Maquininha', qtd: alvoMaquininha.length,
      comZap: comTelefone(alvoMaquininha).length, prio: PRIORIDADE.maquininha,
      valor: null, semFaixa: 0 },  // receita vem do take rate, nao e MRR fixo
  ].filter(o => o.qtd > 0)
   .sort((a, b) => a.prio - b.prio || (b.valor || 0) - (a.valor || 0))
   .slice(0, 4);

  const abrirOportunidade = (o) => {
    setFiltro(o.chave);
    const alvo = (c) => o.chave === '__sem_maquininha' ? !temMaquininha(c)
      : o.chave.startsWith('naoia:') ? !getIaModulos(c).includes(o.chave.slice(6))
      : !getProdutos(c).includes(o.chave.slice(4));
    setSelected(new Set(comTelefone(clientes.filter(c => c.statusContrato === 'Ativo' && alvo(c))).map(c => c.id)));
    document.getElementById('lista-clientes')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  const toggleSel = (id) => setSelected(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const selecionarPorStatus = (status) => {
    const ids = comTelefone(ordenados.filter(c => !status || c.statusContrato === status)).map(c => c.id);
    setSelected(new Set(ids));
  };
  const selecionados = clientes.filter(c => selected.has(c.id) && c.telefone);
  const semTelefone  = clientes.filter(c => !c.telefone).length;

  // Exporta o que está na tela (respeita busca e filtro). Se houver seleção,
  // exporta só os selecionados — inclusive quem não tem WhatsApp.
  const selParaExport = clientes.filter(c => selected.has(c.id));
  const fonteExport   = selParaExport.length ? selParaExport : ordenados;
  const baixarPlanilha = async () => {
    if (!fonteExport.length) return;
    setExportando(true);
    try {
      const hoje = new Date().toISOString().slice(0, 10);
      const tipo = await exportarClientes(fonteExport, `clientes_${hoje}`, podeValores);
      if (tipo === 'csv') {
        alert('⚠️ A biblioteca de XLSX não está instalada no projeto, então baixei em CSV — abre no Excel normalmente.\n\nPara sair em .xlsx, rode "npm install xlsx".');
      }
    } catch (e) {
      alert('⚠️ Não consegui gerar a planilha: ' + (e?.message || e));
    } finally { setExportando(false); }
  };
  const irParaDisparo = () => {
    if (!selecionados.length) return;
    setParaDisparo(selecionados.map(c => ({ telefone: c.telefone, nome: c.nome })));
    navigate('/disparo');
  };
  const mrr_total  = clientes.reduce((s, c) => s + mrrEfetivo(c), 0);
  const ativos     = clientes.filter(c => c.statusContrato === 'Ativo').length;
  const cancelados = clientes.filter(c => c.statusContrato === 'Cancelado').length;

  // quantos chamados abertos cada cliente tem — vira o selo na linha
  const abertosPorCliente = {};
  chamados.forEach(ch => {
    if (!ABERTOS.includes(ch.status)) return;
    abertosPorCliente[ch.clienteRef] = (abertosPorCliente[ch.clienteRef] || 0) + 1;
  });
  const totalAbertos = chamados.filter(ch => ABERTOS.includes(ch.status)).length;

  if (loading) return (
    <div style={{ textAlign: 'center', padding: '80px', color: '#9898b8' }}>Carregando clientes...</div>
  );

  return (
    <div style={{ maxWidth: '960px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between',
        alignItems: 'flex-start', marginBottom: '28px' }}>
        <div>
          <h1 style={{ fontFamily: 'Syne, sans-serif', fontSize: '26px',
            fontWeight: '800', letterSpacing: '-0.5px', marginBottom: '6px' }}>Clientes</h1>
          <p style={{ color: '#52526e', fontSize: '13px' }}>
            Carteira de salões com produtos Avec.
            {salvando && <span style={{ color: '#6c47ff', marginLeft: '8px' }}>💾 Salvando...</span>}
          </p>
        </div>
        <div style={{ display: 'flex', gap: '10px', visibility: aba === 'clientes' ? 'visible' : 'hidden' }}>
          <input ref={fileRef} type="file" accept=".csv,.tsv,.txt,.xlsx,.xls"
            style={{ display: 'none' }} onChange={handleUpload} />
          {pode('carteira') && (
          <button onClick={() => fileRef.current.click()} disabled={uploading}
            style={{ border: '1.5px solid rgba(108,71,255,0.3)', background: 'rgba(108,71,255,0.06)',
              color: '#6c47ff', borderRadius: '10px', padding: '10px 18px',
              fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
            {uploading ? '⏳ Importando...' : '📥 Atualizar base'}
          </button>
          )}
          <button onClick={baixarPlanilha} disabled={exportando || !clientes.length}
            title={!clientes.length ? 'Nenhum cliente para exportar'
                 : selParaExport.length ? `Exportar os ${selParaExport.length} selecionados`
                 : `Exportar os ${ordenados.length} clientes desta lista`}
            style={{ border: '1.5px solid rgba(5,150,105,0.35)', background: 'rgba(5,150,105,0.06)',
              color: '#047857', borderRadius: '10px', padding: '10px 18px',
              fontSize: '13px', fontWeight: '600',
              cursor: (exportando || !clientes.length) ? 'not-allowed' : 'pointer',
              opacity: clientes.length ? 1 : 0.5 }}>
            {exportando ? '⏳ Gerando...' : `📤 Exportar planilha${clientes.length ? ` (${fonteExport.length})` : ''}`}
          </button>
          <button onClick={() => { setClienteEditando(null); setModal(true); }}
            style={{ background: 'linear-gradient(135deg, #6c47ff, #5535e0)',
              color: '#fff', border: 'none', borderRadius: '10px',
              padding: '11px 22px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}>
            + Novo cliente
          </button>
        </div>
      </div>

      {/* Sub-abas: a fila do suporte mora aqui dentro, sem rota nem menu novo */}
      <div style={{ display: 'flex', gap: '6px', marginBottom: '20px', borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
        {[['clientes', 'Carteira', clientes.length], ['chamados', '🎫 Chamados', totalAbertos]].map(([k, l, n]) => (
          <button key={k} onClick={() => setAba(k)} style={{
            border: 'none', background: 'none', cursor: 'pointer', padding: '10px 4px', marginRight: '18px',
            fontFamily: 'Syne, sans-serif', fontSize: '14px',
            fontWeight: aba === k ? '800' : '600',
            color: aba === k ? '#6c47ff' : '#9898b8',
            borderBottom: '2.5px solid ' + (aba === k ? '#6c47ff' : 'transparent'),
            marginBottom: '-1px' }}>
            {l}
            {n > 0 && (
              <span style={{ fontFamily: 'monospace', fontSize: '11px', fontWeight: '700', marginLeft: '7px',
                padding: '1px 7px', borderRadius: '20px',
                background: k === 'chamados' ? 'rgba(239,68,68,0.1)' : 'rgba(0,0,0,0.06)',
                color: k === 'chamados' ? '#dc2626' : '#52526e' }}>{n}</span>
            )}
          </button>
        ))}
      </div>

      {aba === 'chamados' && (
        <FilaChamados chamados={chamados} clientes={clientes}
          onNovo={() => setChamadoAberto(chamadoVazio(null))}
          onAbrir={(ch) => setChamadoAberto(ch)} />
      )}

      {aba === 'clientes' && (<>

      {clientes.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: `repeat(${podeValores ? 4 : 3},1fr)`, gap: '12px', marginBottom: '24px' }}>
          {[
            { label: 'Total clientes', value: clientes.length },
            { label: 'Ativos',         value: ativos,     color: '#059669' },
            { label: 'Cancelados',     value: cancelados, color: cancelados > 0 ? '#dc2626' : undefined },
            ...(podeValores ? [{ label: 'MRR total', value: `R$${mrr_total.toLocaleString('pt-BR',{minimumFractionDigits:2})}`, color: '#059669' }] : []),
          ].map(m => (
            <div key={m.label} style={{ background: '#fff', border: '1px solid rgba(0,0,0,0.08)',
              borderRadius: '12px', padding: '16px 18px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
              <div style={{ fontSize: '10px', color: '#9898b8', fontFamily: 'monospace',
                textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '6px' }}>{m.label}</div>
              <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '20px', fontWeight: '800',
                color: m.color || '#0a0a18' }}>{m.value}</div>
            </div>
          ))}
        </div>
      )}

      {podeValores && oportunidades.length > 0 && (
        <div style={{ marginBottom: '18px' }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', marginBottom: '8px' }}>
            <span style={{ fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: '15px' }}>
              💡 Oportunidades na sua carteira
            </span>
            <span style={{ fontSize: '12px', color: '#52526e' }}>
              clientes ativos que ainda não têm cada item — clique para já selecionar e disparar
            </span>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: `repeat(${Math.min(oportunidades.length, 4)}, 1fr)`, gap: '10px' }}>
            {oportunidades.map(o => {
              const ativo = filtro === o.chave;
              return (
                <button key={o.chave} onClick={() => abrirOportunidade(o)}
                  style={{
                    textAlign: 'left', cursor: 'pointer', padding: '14px',
                    borderRadius: '12px', background: '#fff',
                    border: '1.5px solid ' + (ativo ? '#6c47ff' : 'rgba(16,185,129,0.25)'),
                    boxShadow: ativo ? '0 0 0 3px rgba(108,71,255,0.12)' : '0 1px 3px rgba(0,0,0,0.05)',
                    transition: 'all 0.15s', fontFamily: 'DM Sans, sans-serif',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'none'; }}>
                  <div style={{ fontSize: '11px', color: '#52526e', fontFamily: 'monospace', fontWeight: '700',
                    textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '6px' }}>
                    Sem {o.label}
                  </div>
                  <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: '22px', color: '#059669' }}>
                    {o.valor === null
                      ? <>{o.qtd} <span style={{ fontSize: '13px', fontWeight: '600', color: '#52526e' }}>para ativar</span></>
                      : <>+R${o.valor.toLocaleString('pt-BR', { maximumFractionDigits: 0 })}
                         <span style={{ fontSize: '11px', fontWeight: '600', color: '#9898b8' }}>/mês</span></>}
                  </div>
                  <div style={{ fontSize: '11px', color: '#52526e', marginTop: '4px' }}>
                    {o.valor === null
                      ? <span style={{ color: '#9898b8' }}>receita por transação, não é mensalidade</span>
                      : <>{o.qtd} cliente{o.qtd > 1 ? 's' : ''}</>}
                    {o.comZap > 0
                      ? <span style={{ color: '#6c47ff', fontWeight: '600' }}> · {o.comZap} com WhatsApp 🚀</span>
                      : <span style={{ color: '#d97706' }}> · sem WhatsApp cadastrado</span>}
                  </div>
                  {o.semFaixa > 0 && (
                    <div style={{ fontSize: '10px', color: '#d97706', marginTop: '4px' }}>
                      +{o.semFaixa} sem plano identificado, fora da conta
                    </div>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      )}

      {clientes.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 200px 150px 78px', gap: '10px', marginBottom: '12px' }}>
          <input value={busca} onChange={e => setBusca(e.target.value)}
            placeholder="Buscar por nome, ID, documento ou e-mail..." style={inp} />
          {/* filtro de campanha: quem NAO tem determinado produto e o alvo da oferta */}
          <select value={filtro} onChange={e => setFiltro(e.target.value)} style={{ ...inp, cursor: 'pointer' }}>
            <option value="">Todos os clientes</option>
            <option value="__sem_fiscal">Sem módulo fiscal</option>
            <option value="__sem_ia">Sem nenhum módulo de IA</option>
            <option value="__sem_whatsapp">Sem WhatsApp cadastrado</option>
            <option value="__aniversario">Com aniversário cadastrado</option>
            <option value="__com_ia">Com algum módulo de IA</option>
            <option value="__sem_maquininha">Sem maquininha ativa</option>
            <option value="__com_whatsapp">Com WhatsApp cadastrado</option>
            <optgroup label="NÃO tem o produto (alvo de oferta)">
              {CATALOGO_MODULOS.filter(p => !/sms/i.test(p.nome)).map(p => <option key={'n' + p.nome} value={'nao:' + p.nome}>Sem {p.nome}</option>)}
              {IA_MODS.map(m => <option key={'ni' + m.key} value={'naoia:' + m.key}>Sem IA {m.nome}</option>)}
            </optgroup>
            <optgroup label="Tem o produto">
              {PRODUTOS_AVEC.map(p => <option key={p.nome} value={'tem:' + p.nome}>{p.nome}</option>)}
              {IA_MODS.map(m => <option key={'i' + m.key} value={'temia:' + m.key}>IA {m.nome}</option>)}
            </optgroup>
          </select>
          <select value={ordem} onChange={e => trocarOrdem(e.target.value)} style={{ ...inp, cursor: 'pointer' }}>
            <option value="nome">Nome (A-Z)</option>
            {podeValores && <option value="mrr">Maior MRR</option>}
            <option value="exp">Vence antes</option>
            <option value="status">Status</option>
          </select>
          <div style={{ display: 'flex', border: '1.5px solid rgba(0,0,0,0.1)', borderRadius: '9px', overflow: 'hidden', background: '#f8f8fc' }}>
            {[['lista', '☰', 'Lista'], ['cards', '▦', 'Cards']].map(([v, ico, titulo]) => (
              <button key={v} onClick={() => trocarVisao(v)} title={titulo}
                style={{ flex: 1, border: 'none', cursor: 'pointer', fontSize: '15px',
                  background: visao === v ? '#6c47ff' : 'transparent',
                  color: visao === v ? '#fff' : '#9898b8' }}>{ico}</button>
            ))}
          </div>
        </div>
      )}

      {clientes.length > 0 && (
        <div style={{ background: '#fff', border: '1px solid rgba(0,0,0,0.08)', borderRadius: '12px', padding: '12px 16px',
          marginBottom: '16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
            <span style={{ fontSize: '11px', color: '#9898b8', fontFamily: 'monospace', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Selecionar</span>
            <button onClick={() => selecionarPorStatus('Ativo')} style={btnGhost}>Ativos</button>
            <button onClick={() => selecionarPorStatus('Cancelado')} style={btnGhost}>Cancelados</button>
            <button onClick={() => selecionarPorStatus('')} style={btnGhost}>{busca || filtro ? 'Todos do filtro' : 'Todos'}</button>
            {selected.size > 0 && <button onClick={() => setSelected(new Set())} style={btnGhost}>Limpar seleção</button>}
            {filtro && <button onClick={() => { setFiltro(''); setSelected(new Set()); }} style={btnGhost}>✕ Tirar filtro</button>}
            {semTelefone > 0 && (
              <span style={{ fontSize: '11px', color: '#d97706' }}>
                · {semTelefone} sem WhatsApp{comTelefone(clientes).length === 0 ? ' — preencha o telefone no cadastro para poder disparar' : ' cadastrado'}
              </span>
            )}
          </div>
          <button onClick={irParaDisparo} disabled={!selecionados.length}
            title={selecionados.length ? `Disparar para ${selecionados.length}`
                 : comTelefone(ordenados).length === 0
                   ? 'Nenhum cliente da lista tem WhatsApp cadastrado — só dá pra disparar depois de preencher o telefone'
                   : 'Marque os clientes na lista, ou use os botões de Selecionar'}
            style={{
            background: selecionados.length ? 'linear-gradient(135deg, #6c47ff, #5535e0)' : '#e5e7eb',
            color: selecionados.length ? '#fff' : '#9898b8', border: 'none', borderRadius: '8px', padding: '8px 16px',
            fontSize: '12px', fontWeight: '600', cursor: selecionados.length ? 'pointer' : 'not-allowed', whiteSpace: 'nowrap' }}>
            🚀 Disparar para {selecionados.length} →
          </button>
        </div>
      )}

      {clientes.length === 0 && (
        <div style={{ background: 'rgba(108,71,255,0.04)', border: '1px dashed rgba(108,71,255,0.2)',
          borderRadius: '12px', padding: '16px 20px', marginBottom: '20px',
          fontSize: '12px', color: '#6c47ff', fontFamily: 'monospace', lineHeight: '1.8' }}>
          💡 Importe uma planilha <strong>CSV, TSV ou XLSX</strong> (o separador é detectado sozinho). Colunas:<br />
          <span style={{ color: '#52526e' }}>
            Cliente ID · Documento · Nome · Email · <strong>Telefone</strong> (WhatsApp com DDD) · Sistema Cobranca · Status · Periodicidade ·
            Ativacao · Expiracao · <strong>Aniversario</strong> · Contato · Observacao · <strong>IA Modulos</strong> · IA Faixa · Nome Contrato · Nome Componente
            (ou uma coluna <strong>Produtos</strong> separada por | ) · <strong>Valor</strong> (opcional, p/ negociado)<br />
            <span style={{ color: '#9898b8' }}>Reimportar não apaga nada: atualiza contrato e preserva WhatsApp, e-mail e aniversário.</span>
          </span>
        </div>
      )}

      {podeValores && potencial > 0 && (
        <div style={{ background: 'rgba(16,185,129,0.07)', border: '1px solid rgba(16,185,129,0.22)',
          borderRadius: '10px', padding: '12px 16px', marginBottom: '12px', fontSize: '13px', color: '#047857' }}>
          <strong>{ativosDoFiltro.length} cliente(s) ativos nesta lista não têm esse item.</strong>{' '}
          Se todos fechassem, seriam{' '}
          <strong>+R$ {potencial.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}/mês</strong> de MRR.
          {comTelefone(ativosDoFiltro).length !== ativosDoFiltro.length && (
            <span style={{ color: '#b45309' }}>
              {' '}· {ativosDoFiltro.length - comTelefone(ativosDoFiltro).length} sem WhatsApp, não entram no disparo.
            </span>
          )}
        </div>
      )}

      {ordenados.length > 0 && (
        <div id="lista-clientes" style={{ fontSize: '11px', color: '#9898b8', fontFamily: 'monospace', marginBottom: '8px' }}>
          {ordenados.length === clientes.length
            ? `${clientes.length} clientes`
            : `${ordenados.length} de ${clientes.length} clientes`}
        </div>
      )}

      {filtrados.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#9898b8' }}>
          <div style={{ fontSize: '40px', marginBottom: '12px' }}>👥</div>
          <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '16px', marginBottom: '6px' }}>
            Nenhum cliente ainda</div>
          <div style={{ fontSize: '13px' }}>Adicione manualmente ou importe uma planilha.</div>
        </div>
      ) : visao === 'lista' ? (
        <div style={{ background: '#fff', border: '1px solid rgba(0,0,0,0.08)', borderRadius: '12px',
          overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
          <div style={{ display: 'grid',
            gridTemplateColumns: '26px minmax(0,2.2fr) 88px minmax(0,2.6fr)' + (podeValores ? ' 96px' : ''),
            gap: '10px', padding: '9px 12px', background: '#f8f8fc',
            fontSize: '10px', fontFamily: 'monospace', fontWeight: '700', textTransform: 'uppercase',
            letterSpacing: '0.06em', color: '#52526e' }}>
            <span />
            <span>Cliente</span>
            <span>Status</span>
            <span>Produtos</span>
            {podeValores && <span style={{ textAlign: 'right' }}>MRR</span>}
          </div>
          {ordenados.map(c => (
            <ClienteLinha key={c.id} c={c} selecionado={selected.has(c.id)} onToggle={() => toggleSel(c.id)}
              chamadosAbertos={abertosPorCliente[refDoCliente(c)] || 0} mostrarValor={podeValores}
              onEdit={() => { setClienteEditando(c); setModal(true); }} />
          ))}
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
          {ordenados.map(c => (
            <ClienteCard key={c.id} c={c} selecionado={selected.has(c.id)} onToggle={() => toggleSel(c.id)}
              chamadosAbertos={abertosPorCliente[refDoCliente(c)] || 0} mostrarValor={podeValores}
              onEdit={() => { setClienteEditando(c); setModal(true); }} />
          ))}
        </div>
      )}

      </>)}

      {modal && (
        <ClienteModal onClose={() => setModal(false)} onSave={salvarCliente} clienteEditando={clienteEditando}
          mostrarValor={podeValores}
          chamados={clienteEditando ? chamadosDoCliente(clienteEditando) : []}
          onNovoChamado={() => setChamadoAberto(chamadoVazio(clienteEditando))}
          onAbrirChamado={(ch) => setChamadoAberto(ch)} />
      )}

      {chamadoAberto && (
        <ChamadoModal chamado={chamadoAberto} clientes={clientes}
          onClose={() => setChamadoAberto(null)}
          onSalvar={salvarChamado} onExcluir={excluirChamado} />
      )}
    </div>
  );
}

export { fsGet, fsSet, parseIaModulos, fsList, calcMRR, calcMRRCliente, mrrEfetivo, produtoMRR, valorToNumber, PRODUTOS_AVEC, CATALOGO_PLATAFORMA, CATALOGO_MODULOS, FB_PROJ,
         mesclarClientes, clientesToFields, docToClientes, mesAtual, dataISO, normStatus, normPeriodo, valorToNumber as parseValor };

const secTitle = { fontSize: '10px', fontWeight: '700', color: '#6c47ff',
  textTransform: 'uppercase', letterSpacing: '0.1em', fontFamily: 'monospace',
  marginBottom: '12px', paddingBottom: '6px', borderBottom: '1px solid rgba(108,71,255,0.1)' };
const lbl = { fontSize: '11px', fontWeight: '700', color: '#52526e',
  textTransform: 'uppercase', letterSpacing: '0.06em',
  fontFamily: 'monospace', display: 'block', marginBottom: '6px' };
const inp = { width: '100%', padding: '10px 12px', borderRadius: '9px',
  border: '1.5px solid rgba(0,0,0,0.1)', fontSize: '14px', background: '#f8f8fc',
  outline: 'none', boxSizing: 'border-box', fontFamily: 'DM Sans, sans-serif', color: '#0a0a18' };
const btnGhost = { border: '1.5px solid rgba(0,0,0,0.1)', background: 'none',
  borderRadius: '8px', padding: '7px 14px', fontSize: '12px',
  cursor: 'pointer', color: '#52526e', fontFamily: 'DM Sans, sans-serif' };
